
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2CHXX", function(module, exports) {

var $1P1Tu = parcelRequire("1P1Tu");


var $bPHr8 = parcelRequire("bPHr8");

const $50c358168d133df8$export$a08ae3ac6db36809 = 'EMPTY_CONVERSATION_ID';
const $50c358168d133df8$var$initialState = {
    conversations: {
        EMPTY_CONVERSATION_ID: {
            id: $50c358168d133df8$export$a08ae3ac6db36809,
            messages: [],
            name: '',
            status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
            traces: [],
            timeCreated: new Date().toISOString()
        }
    },
    currentConversationId: $50c358168d133df8$export$a08ae3ac6db36809,
    isConversationsInitialized: false,
    conversationPagination: {
        ...(0, $bPHr8.DEFAULT_CONVERSATION_PAGINATION)
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $50c358168d133df8$var$store;
const $50c358168d133df8$export$8572e013e9dc20c3 = (actions)=>{
    if (!$50c358168d133df8$var$store) $50c358168d133df8$var$store = (0, $1P1Tu.createStore)({
        name: 'ConversationAssistantStore',
        initialState: $50c358168d133df8$var$initialState,
        actions: actions
    });
    // The module-level `store` is typed as `any` because its action type T is
    // not known at declaration time. The cast here is safe: `createChatStore` is
    // always called with the same concrete actions object.
    return $50c358168d133df8$var$store;
};
module.exports["EMPTY_CONVERSATION_ID"] = $50c358168d133df8$export$a08ae3ac6db36809;
module.exports["createChatStore"] = $50c358168d133df8$export$8572e013e9dc20c3;

});

parcelRegister("bPHr8", function(module, exports) {
var $6ad1677b7b0380c5$export$69799355b7de2229 = /*#__PURE__*/ function(StoreActionLoggableName) {
    StoreActionLoggableName["addStoreChatItem"] = "addStoreChatItem";
    StoreActionLoggableName["addHumanMessage"] = "addHumanMessage";
    StoreActionLoggableName["addAssistantMessage"] = "addAssistantMessage";
    StoreActionLoggableName["clearFollowUpMessages"] = "clearFollowUpMessages";
    StoreActionLoggableName["sendMessage"] = "sendMessage";
    StoreActionLoggableName["sendMessageConfirmedTools"] = "sendMessageConfirmedTools";
    StoreActionLoggableName["removeMessage"] = "removeMessage";
    StoreActionLoggableName["truncateFromLastHumanMessage"] = "truncateFromLastHumanMessage";
    StoreActionLoggableName["fetchConversation"] = "fetchConversation";
    StoreActionLoggableName["prefetchConversationMessages"] = "prefetchConversationMessages";
    StoreActionLoggableName["reconnectToInProgressStream"] = "reconnectToInProgressStream";
    StoreActionLoggableName["abortRequests"] = "abortRequests";
    StoreActionLoggableName["answerNow"] = "answerNow";
    StoreActionLoggableName["addErrorMessage"] = "addErrorMessage";
    StoreActionLoggableName["fetchConversationChannelsData"] = "fetchConversationChannelsData";
    StoreActionLoggableName["loadMoreConversationChannelsData"] = "loadMoreConversationChannelsData";
    StoreActionLoggableName["hydrateConversation"] = "hydrateConversation";
    StoreActionLoggableName["addAgentMessage"] = "addAgentMessage";
    StoreActionLoggableName["handleChatOpenPubsubAction"] = "handleChatOpenPubsubAction";
    StoreActionLoggableName["createConversationOptimistically"] = "createConversationOptimistically";
    StoreActionLoggableName["createSeededConversation"] = "createSeededConversation";
    StoreActionLoggableName["updateActionInvocationStatus"] = "updateActionInvocationStatus";
    StoreActionLoggableName["updateActionData"] = "updateActionData";
    StoreActionLoggableName["resolveConversationAction"] = "resolveConversationAction";
    StoreActionLoggableName["bulkResolveConversationActions"] = "bulkResolveConversationActions";
    StoreActionLoggableName["bulkResolveConversationUIActions"] = "bulkResolveConversationUIActions";
    StoreActionLoggableName["setSelectedConversation"] = "setSelectedConversation";
    StoreActionLoggableName["warmConversationCache"] = "warmConversationCache";
    StoreActionLoggableName["hasConversationMessages"] = "hasConversationMessages";
    StoreActionLoggableName["stopTask"] = "stopTask";
    return StoreActionLoggableName;
}({});
const $6ad1677b7b0380c5$export$61e8a5ac076d12b3 = {
    nextCursor: null,
    hasMore: false,
    isLoadingMore: false,
    loadMoreError: null,
    isConversationListMounted: false
};
const $6ad1677b7b0380c5$export$8ec4190061b584d5 = (status)=>status?.type === 'AVAILABLE';
const $6ad1677b7b0380c5$export$fe950e85847f6d5d = {
    AVAILABLE: 'AVAILABLE',
    SWITCHING: 'SWITCHING',
    SWITCHING_REQUESTED: 'SWITCHING_REQUESTED',
    SWITCHED: 'SWITCHED',
    ERRORED: 'ERRORED'
};
var $6ad1677b7b0380c5$export$817d6b1b984afeb7 = /*#__PURE__*/ function(CHAT_STORE_STATUS) {
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["idle"] = 0] = "idle";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["loadingChat"] = 1] = "loadingChat";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["awaitingResponse"] = 2] = "awaitingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["typingResponse"] = 3] = "typingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["deactivatedAgentError"] = 4] = "deactivatedAgentError";
    return CHAT_STORE_STATUS;
}({});
const $6ad1677b7b0380c5$var$TERMINAL_TASK_STATES = [
    'Completed',
    'Failed',
    'Cancelled'
];
const $6ad1677b7b0380c5$export$e87901ebf76c08a1 = (state)=>$6ad1677b7b0380c5$var$TERMINAL_TASK_STATES.includes(state);
const $6ad1677b7b0380c5$export$75e97486ff2b4c62 = (message)=>'type' in message && message.type === 'HUMAN';
const $6ad1677b7b0380c5$export$d99f52ae2a325014 = (message)=>'type' in message && message.type === 'ASSISTANT';
const $6ad1677b7b0380c5$export$9e2d714e96946d26 = (message)=>'type' in message && message.type === 'ERROR';
const $6ad1677b7b0380c5$export$f2b8d80523e7041 = (message)=>$6ad1677b7b0380c5$export$75e97486ff2b4c62(message) || $6ad1677b7b0380c5$export$d99f52ae2a325014(message);
const $6ad1677b7b0380c5$export$61c7dbb423a56ae7 = (message)=>'type' in message && message.type === 'MEMORY_UPDATE';
const $6ad1677b7b0380c5$export$7c65a4fb7b6131a1 = (message)=>'type' in message && message.type === 'FOLLOW_UP';
const $6ad1677b7b0380c5$export$2e85f4812cb59241 = (message)=>'type' in message && message.type === 'LIVE_CHAT';
const $6ad1677b7b0380c5$export$20f0f8aded5b11e5 = (message)=>'type' in message && message.type === 'TWILIO_LIVE_CHAT_AGENT';
const $6ad1677b7b0380c5$export$908578fde1b22b55 = (message)=>$6ad1677b7b0380c5$export$75e97486ff2b4c62(message) && message.source === 'TWILIO_LIVE_CHAT';
const $6ad1677b7b0380c5$export$3db8a80b25c44828 = (message)=>$6ad1677b7b0380c5$export$20f0f8aded5b11e5(message) || $6ad1677b7b0380c5$export$908578fde1b22b55(message);
const $6ad1677b7b0380c5$export$d15e7fe0f58ee5d0 = (message)=>message.type === 'ACTION_PREPARE';
const $6ad1677b7b0380c5$export$533a80cec0f4f28f = (message)=>message.type === 'GUARD_BLOCK';
const $6ad1677b7b0380c5$export$155f16100a67670d = (message)=>'type' in message && message.type === 'USAGE_HINT';
const $6ad1677b7b0380c5$export$3070678f252266e3 = (invocationId, invokedActions)=>invokedActions && invokedActions[invocationId] || 'idle';
module.exports["StoreActionLoggableName"] = $6ad1677b7b0380c5$export$69799355b7de2229;
module.exports["DEFAULT_CONVERSATION_PAGINATION"] = $6ad1677b7b0380c5$export$61e8a5ac076d12b3;
module.exports["isAnswerNowAvailable"] = $6ad1677b7b0380c5$export$8ec4190061b584d5;
module.exports["AnswerNowStatusType"] = $6ad1677b7b0380c5$export$fe950e85847f6d5d;
module.exports["CHAT_STORE_STATUS"] = $6ad1677b7b0380c5$export$817d6b1b984afeb7;
module.exports["isTerminalTaskState"] = $6ad1677b7b0380c5$export$e87901ebf76c08a1;
module.exports["isStoreHuman"] = $6ad1677b7b0380c5$export$75e97486ff2b4c62;
module.exports["isStoreAssistant"] = $6ad1677b7b0380c5$export$d99f52ae2a325014;
module.exports["isStoreError"] = $6ad1677b7b0380c5$export$9e2d714e96946d26;
module.exports["isStoreMessage"] = $6ad1677b7b0380c5$export$f2b8d80523e7041;
module.exports["isStoreFollowUp"] = $6ad1677b7b0380c5$export$7c65a4fb7b6131a1;
module.exports["isStoreGuardBlock"] = $6ad1677b7b0380c5$export$533a80cec0f4f28f;
module.exports["isStoreUsageHint"] = $6ad1677b7b0380c5$export$155f16100a67670d;
module.exports["getActionInvocationStatus"] = $6ad1677b7b0380c5$export$3070678f252266e3;

});

parcelRegister("2O3ot", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $abb9e481ac8f38e8$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: '',
    dynamicUiType: undefined,
    dynamicUiSubtype: undefined,
    dynamicUiSource: undefined,
    isRemixUpdating: false,
    forceSkipAutoConversationSelection: false,
    currentDisplayMessageId: undefined
};
const $abb9e481ac8f38e8$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setStagingAreaEntryPoint: (entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        },
    getInvocationIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().invocationIdSelectedForPreview;
        },
    setIsRemixUpdating: (isUpdating)=>({ setState: setState })=>{
            setState({
                isRemixUpdating: isUpdating
            });
        },
    setDynamicUiContext: (dynamicUiType, dynamicUiSubtype, dynamicUiSource)=>({ setState: setState })=>{
            setState({
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource
            });
        },
    resetStagingArea: ()=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: null,
                invocationIdSelectedForPreview: null,
                isRemixUpdating: false,
                stagingAreaMode: undefined,
                stagingAreaEntryPoint: '',
                dynamicUiType: undefined,
                dynamicUiSubtype: undefined,
                dynamicUiSource: undefined,
                forceSkipAutoConversationSelection: false,
                currentDisplayMessageId: undefined
            });
        },
    setForceSkipAutoConversationSelection: (forceSkip)=>({ setState: setState })=>{
            setState({
                forceSkipAutoConversationSelection: forceSkip
            });
        },
    setCurrentDisplayMessageId: (messageId)=>({ setState: setState })=>{
            setState({
                currentDisplayMessageId: messageId
            });
        }
};
const $abb9e481ac8f38e8$var$store = (0, $1P1Tu.createStore)({
    initialState: $abb9e481ac8f38e8$var$initialState,
    actions: $abb9e481ac8f38e8$var$actions
});
const $abb9e481ac8f38e8$export$a2795b51ce92008f = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $abb9e481ac8f38e8$export$916334da9df8d04 = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$8f9a13b17bec42d5 = (0, $9zUhf.createActionsHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$5a57f796673aabea = (0, $9zUhf.createStateHook)($abb9e481ac8f38e8$var$store);
module.exports["useMessageIdSelectedForPreview"] = $abb9e481ac8f38e8$export$a2795b51ce92008f;
module.exports["useStagingArea"] = $abb9e481ac8f38e8$export$916334da9df8d04;
module.exports["useStagingAreaActions"] = $abb9e481ac8f38e8$export$8f9a13b17bec42d5;
module.exports["useStagingAreaState"] = $abb9e481ac8f38e8$export$5a57f796673aabea;

});

parcelRegister("4pEXC", function(module, exports) {
/* eslint-disable @atlaskit/platform/one-value-export-per-file -- This file predates the rule and is a shared subpath entry point consumed by many packages; splitting would require coordinated changes across the entire monorepo. */ 
var $b0F8r = parcelRequire("b0F8r");


var $b7FrM = parcelRequire("b7FrM");


var $lpRYt = parcelRequire("lpRYt");


var $ij2FZ = parcelRequire("ij2FZ");

const $cdcb92bd6c40797f$export$d801201dc544181 = (content)=>{
    /*
  This try-catch is a necessary guard rail against broken content to prevent higher level
  error boundaries from displaying the error and breaking the experience.
  */ try {
        return typeof content !== 'string' && 'type' in content && content.type === 'doc';
    } catch  {
        return false;
    }
};
const $cdcb92bd6c40797f$export$a236f395afded7e0 = (content, suggestionContent)=>{
    if ($cdcb92bd6c40797f$export$d801201dc544181(content)) {
        // Ensure the content is an array of nodes
        const updatedContent = Array.isArray(content.content) ? content.content : [
            content.content
        ];
        // Append the new paragraph node
        updatedContent.push({
            type: 'paragraph',
            content: [
                {
                    type: 'text',
                    text: suggestionContent
                }
            ]
        });
        // Return the updated DocNode
        return {
            ...content,
            content: updatedContent
        };
    }
    return `${content}\n\n${suggestionContent}`;
};
const $cdcb92bd6c40797f$var$pluginConfig = {
    linkify: {
        findFilepaths: $b0F8r.findFilepaths,
        isLinkInMatches: $b0F8r.isLinkInMatches
    },
    smartLinks: {
        regexStorage: globalThis.localStorage
    }
};
const $cdcb92bd6c40797f$export$3374c63d7715b4ce = new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, false));
const $cdcb92bd6c40797f$var$streamingAdfEncoder = new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, true));
const $cdcb92bd6c40797f$export$53ded0b846f45216 = (content, streaming = false, isExperimentEnabled, shouldShowAsInline, useGroupedCitations, xpcWrapUrl)=>{
    if ($cdcb92bd6c40797f$export$d801201dc544181(content)) return content;
    if (isExperimentEnabled || shouldShowAsInline || xpcWrapUrl) return new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, undefined, xpcWrapUrl)).encode(content);
    else if (useGroupedCitations) return streaming ? new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, true, undefined, undefined, true)).encode(content) : new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, useGroupedCitations)).encode(content);
    else return streaming ? $cdcb92bd6c40797f$var$streamingAdfEncoder.encode(content) : $cdcb92bd6c40797f$export$3374c63d7715b4ce.encode(content);
};
const $cdcb92bd6c40797f$export$cc924f6f2bb49b7c = (content)=>{
    const contentNodes = [];
    let lastIndex = 0;
    let match;
    let promptLength = 0;
    // Find all skill tag matches
    const matches = [];
    while((match = (0, $ij2FZ.ROVO_SKILL_TAG_PATTERN).exec(content)) !== null)matches.push({
        index: match.index,
        skillSlug: match[1],
        // The skill name without the slash
        length: match[0].length // Length of "/skill-name"
    });
    // Process the string segment by segment
    for(let i = 0; i < matches.length; i++){
        const currentMatch = matches[i];
        const matchStart = currentMatch.index;
        const matchEnd = matchStart + currentMatch.length;
        // Add text before the skill tag (if any)
        if (matchStart > lastIndex) {
            const textBefore = content.substring(lastIndex, matchStart);
            if (textBefore) {
                contentNodes.push({
                    type: 'text',
                    text: textBefore
                });
                promptLength += textBefore.length;
            }
        }
        // Add the skill tag as inlineExtension
        contentNodes.push({
            type: 'inlineExtension',
            attrs: {
                extensionKey: (0, $ij2FZ.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                extensionType: (0, $ij2FZ.ROVO_SKILL_EXTENSION_TYPE),
                parameters: {
                    slug: currentMatch.skillSlug
                }
            }
        });
        promptLength += 1;
        lastIndex = matchEnd;
    }
    // Add remaining text after the last match (if any)
    if (lastIndex < content.length) {
        const textAfter = content.substring(lastIndex);
        if (textAfter) {
            contentNodes.push({
                type: 'text',
                text: textAfter
            });
            promptLength += textAfter.length;
        }
    }
    // If no matches were found, return the entire string as text
    if (contentNodes.length === 0) {
        contentNodes.push({
            type: 'text',
            text: content
        });
        promptLength += content.length;
    }
    return {
        adf: {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: contentNodes
                }
            ]
        },
        promptLength: promptLength
    };
};
const $cdcb92bd6c40797f$export$b663bc0d84e6eaa6 = '`';
// encodeAdf removes leading spaces, so prepend a text node with the segment's leading spaces to preserve them.
const $cdcb92bd6c40797f$var$preserveLeadingSpaces = (textSegment, nodes)=>{
    const leading = textSegment.match(/^\s*/)?.[0] ?? '';
    if (leading.length === 0) return nodes;
    return [
        {
            type: 'text',
            text: leading
        },
        ...nodes
    ];
};
// Collect all content nodes from all top-level blocks, since encodeAdf can return multiple paragraphs for e.g. "line1\n\nline2".
const $cdcb92bd6c40797f$var$getAllNodesFromSegmentAdf = (segmentAdf, fallbackSegment)=>{
    const blocks = segmentAdf.content ?? [];
    if (blocks.length === 0) return [
        {
            type: 'text',
            text: fallbackSegment
        }
    ];
    const nodes = blocks.flatMap((block)=>block.content ?? []);
    return nodes.length > 0 ? nodes : [
        {
            type: 'text',
            text: fallbackSegment
        }
    ];
};
const $cdcb92bd6c40797f$var$detectSkills = (content, skillMetadata)=>{
    if (!skillMetadata) return [];
    const regex = new RegExp((0, $ij2FZ.ROVO_SKILL_TAG_PATTERN).source, 'g');
    const matches = [
        ...content.matchAll(regex)
    ];
    if (matches.length === 0) return [];
    return matches.filter((m)=>m[1] in skillMetadata).map((m)=>({
            index: m.index ?? 0,
            slug: m[1],
            length: m[0].length
        }));
};
// The conversation input editor only supports a limited set of block node types.
// Convert unsupported block nodes to paragraph nodes so that prompts containing
// markdown headings (e.g. "## Title") or horizontal rules (e.g. "---") do not
// trigger "This editor does not support displaying this content: <type>" when inserted.
const $cdcb92bd6c40797f$var$sanitizeAdfForPromptInput = (adf)=>{
    if (!adf.content) return adf;
    return {
        ...adf,
        content: adf.content.flatMap((node)=>{
            if (node.type === 'heading') // Convert heading to paragraph, preserving inner text content
            return [
                {
                    type: 'paragraph',
                    content: node.content
                }
            ];
            if (node.type === 'rule') // Drop horizontal rules entirely — they have no content to preserve
            return [];
            return [
                node
            ];
        })
    };
};
const $cdcb92bd6c40797f$export$20cf1197bba4fe47 = (content, skillMetadata, shouldShowAsInline)=>{
    const skillMatches = $cdcb92bd6c40797f$var$detectSkills(content, skillMetadata);
    if (skillMatches.length === 0) {
        const { placeholderRange: placeholderRange } = $cdcb92bd6c40797f$var$getPlaceholderRange(content, 0);
        return {
            adf: $cdcb92bd6c40797f$var$sanitizeAdfForPromptInput($cdcb92bd6c40797f$export$53ded0b846f45216(content, false, undefined, shouldShowAsInline)),
            promptLength: content.length,
            ...placeholderRange && {
                placeholderRange: placeholderRange
            }
        };
    }
    return $cdcb92bd6c40797f$var$encodePromptWithSkills(content, skillMatches, skillMetadata);
};
const $cdcb92bd6c40797f$var$encodePromptWithSkills = (content, skillMatches, skillMetadata)=>{
    const contentNodes = [];
    let lastIndex = 0;
    let promptLength = 0;
    let placeholderRange;
    for(let i = 0; i < skillMatches.length; i++){
        const currentMatch = skillMatches[i];
        const matchStart = currentMatch.index;
        const matchEnd = matchStart + currentMatch.length;
        // Add text and placeholder range before the skill tag (if any)
        if (matchStart > lastIndex) {
            const textSegment = content.substring(lastIndex, matchStart);
            if (textSegment) {
                const { placeholderRange: range } = $cdcb92bd6c40797f$var$getPlaceholderRange(textSegment, promptLength);
                if (range) placeholderRange = range;
                const segmentAdf = $cdcb92bd6c40797f$export$53ded0b846f45216(textSegment);
                const nodes = $cdcb92bd6c40797f$var$getAllNodesFromSegmentAdf(segmentAdf, textSegment);
                contentNodes.push(...$cdcb92bd6c40797f$var$preserveLeadingSpaces(textSegment, nodes));
                promptLength += textSegment.length;
            }
        }
        // Add the skill tag as inlineExtension
        contentNodes.push({
            type: 'inlineExtension',
            attrs: {
                extensionKey: (0, $ij2FZ.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                extensionType: (0, $ij2FZ.ROVO_SKILL_EXTENSION_TYPE),
                parameters: {
                    slug: currentMatch.slug,
                    ...skillMetadata?.[currentMatch.slug]
                }
            }
        });
        promptLength += 1;
        lastIndex = matchEnd;
    }
    // Add remaining text and placeholder range after the last match (if any)
    if (lastIndex < content.length) {
        const textSegment = content.substring(lastIndex);
        if (textSegment) {
            const { placeholderRange: range } = $cdcb92bd6c40797f$var$getPlaceholderRange(textSegment, promptLength);
            if (range) placeholderRange = range;
            const segmentAdf = $cdcb92bd6c40797f$export$53ded0b846f45216(textSegment);
            const nodes = $cdcb92bd6c40797f$var$getAllNodesFromSegmentAdf(segmentAdf, textSegment);
            contentNodes.push(...$cdcb92bd6c40797f$var$preserveLeadingSpaces(textSegment, nodes));
            promptLength += textSegment.length;
        }
    }
    return {
        adf: {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: contentNodes
                }
            ]
        },
        promptLength: promptLength,
        ...placeholderRange && {
            placeholderRange: placeholderRange
        }
    };
};
// Returns the placeholder range for link typeahead when content has `label` backticks.
const $cdcb92bd6c40797f$var$getPlaceholderRange = (segment, currentContentIndex)=>{
    const firstBacktick = segment.indexOf($cdcb92bd6c40797f$export$b663bc0d84e6eaa6);
    const lastBacktick = segment.lastIndexOf($cdcb92bd6c40797f$export$b663bc0d84e6eaa6);
    if (firstBacktick !== -1 && lastBacktick !== -1 && firstBacktick !== lastBacktick) {
        const label = segment.slice(firstBacktick + 1, lastBacktick);
        const start = currentContentIndex + firstBacktick + 1;
        return {
            placeholderRange: {
                start: start,
                end: start + label.length,
                label: label
            }
        };
    }
    return {};
};
module.exports["isAdfContent"] = $cdcb92bd6c40797f$export$d801201dc544181;
module.exports["appendContent"] = $cdcb92bd6c40797f$export$a236f395afded7e0;
module.exports["adfEncoder"] = $cdcb92bd6c40797f$export$3374c63d7715b4ce;
module.exports["encodeAdf"] = $cdcb92bd6c40797f$export$53ded0b846f45216;
module.exports["encodeSkillPromptToAdf"] = $cdcb92bd6c40797f$export$cc924f6f2bb49b7c;
module.exports["PROMPT_PLACEHOLDER_CHAR"] = $cdcb92bd6c40797f$export$b663bc0d84e6eaa6;
module.exports["encodePromptToAdf"] = $cdcb92bd6c40797f$export$20cf1197bba4fe47;

});

parcelRegister("lpRYt", function(module, exports) {

var $2Yzoe = parcelRequire("2Yzoe");


var $csam1 = parcelRequire("csam1");


var $aRZzN = parcelRequire("aRZzN");


var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $aFrN0 = parcelRequire("aFrN0");


var $kVuPa = parcelRequire("kVuPa");


var $kbmYM = parcelRequire("kbmYM");


var $ijO3G = parcelRequire("ijO3G");


var $guSRW = parcelRequire("guSRW");


var $eqo2H = parcelRequire("eqo2H");


var $kiC47 = parcelRequire("kiC47");


var $b2Usv = parcelRequire("b2Usv");


var $3Jbpl = parcelRequire("3Jbpl");


var $j0P3F = parcelRequire("j0P3F");


var $dSj2z = parcelRequire("dSj2z");


var $1Ce64 = parcelRequire("1Ce64");


var $5XYXq = parcelRequire("5XYXq");


var $7ai6d = parcelRequire("7ai6d");


var $EZ3q4 = parcelRequire("EZ3q4");


var $bCKHR = parcelRequire("bCKHR");

class $2d26328991932579$export$614853bf2169db97 extends (0, $aRZzN.MarkdownTransformer) {
    parse(content) {
        // Sanitize the raw markdown string before it reaches the markdown-it block
        // tokenizer (ParserBlock.tokenize). Indented tables and 4+ space-indented
        // fences can cause catastrophic backtracking / OOM; `sanitizeMarkdown`
        // outdents fences with 4+ spaces of indentation so the parser recognises
        // them as fenced code blocks rather than entering an infinite tokenization
        // loop.
        //
        // Note: md.core.ruler cannot be used here — core rules run AFTER block
        // tokenization, which is too late to prevent the crash. The sanitization
        // must happen on the raw string before parse() is called.
        const node = this.parser.parse((0, $EZ3q4.sanitizeMarkdown)(content));
        if (!node) return new (0, $5SAOw.Node)();
        return node;
    }
    constructor(schema, pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, useGroupedCitations, xpcWrapUrl){
        super();
        this.parser = void 0;
        const md = (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))('zero', {
            html: false
        });
        md.enable([
            // Process html entity - &#123;, &#xAF;, &quot;, ...
            'entity',
            // Process escaped chars and hardbreaks
            'escape',
            'newline'
        ]);
        (0, $bCKHR.enableSchemaPlugins)(md, schema);
        // Handle blockquotes inside list items - ADF doesn't support this nesting,
        // so we transform them into emphasized paragraphs
        md.use((0, $b2Usv.default));
        // enable modified version of linkify plugin
        // @see https://product-fabric.atlassian.net/browse/ED-3097
        md.use((0, $kiC47.createLinkifyPlugin)(pluginConfig.linkify));
        if (useGroupedCitations) md.use((0, $ijO3G.default));
        else md.use((0, $aFrN0.default));
        if ((0, $dh538.fg)('rovo_enable_data_sculptor')) md.use((0, $kVuPa.default));
        md.use((0, $kbmYM.default));
        md.use((0, $5XYXq.default));
        if ((0, $dh538.fg)('rovo_chat_enable_inline_lumina')) md.use((0, $eqo2H.default));
        // Actionable follow-up questions. Exposure is fired earlier, when the `◈`
        // marker is detected during extraction, so this render-time gate is a
        // non-exposure experiment check.
        if (isExperimentEnabled?.('rovo_chat_actionable_follow_ups_exp', false)) md.use((0, $guSRW.default));
        // Convert links with Linking Platform supported URLs to Smart Links
        if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) // this is where we should separate it into its own plugin called createSmartLinksPluginRefresh
        md.use((0, $dSj2z.createSmartLinksPlugin)(pluginConfig.smartLinks, isExperimentEnabled, shouldShowAsInline, xpcWrapUrl));
        // Convert links matching people directory URLs to mentions
        if (schema.nodes.mention) md.use((0, $j0P3F.default));
        // Table support
        if (schema.nodes.table) {
            md.use((0, $csam1.markdownItTable));
            if ((0, $dh538.fg)('rovo_chat_enable_markdown_table_break_tags')) md.use((0, $1Ce64.default));
        }
        // Image support
        if (schema.nodes.media && schema.nodes.mediaSingle) md.use((0, $3Jbpl.default));
        const filter = (0, $bCKHR.filterSchemaMapping)(schema, (0, $7ai6d.mdToPmSchema));
        this.parser = new (0, $42JDa.MarkdownParser)(schema, md, filter);
    }
}
module.exports["AiMateMarkdownTransformer"] = $2d26328991932579$export$614853bf2169db97;

});

parcelRegister("aFrN0", function(module, exports) {
$parcel$export(module.exports, "default", () => $eedc127a683be258$export$2e2bcd8739ae039);
const $eedc127a683be258$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $eedc127a683be258$var$citation = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $eedc127a683be258$var$CITATION_REGEX.test(childToken.content)) {
                /**
           * Example content: `Hello [^1^][^1^].`
           * `parts` will be ['Hello ', '1', '', '1', '.']
           */ const parts = childToken.content.split($eedc127a683be258$var$CITATION_REGEX);
                const newChildren = [];
                /**
           * we want to remove consecutive citation
           * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
           * should be transformed to `Hello 1. How are you 1 2`
           */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
               * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
               * So it doesn't end up rendering empty space that will end up with multi empty spaces
               * because previous valid citation already added 1 empty space
               *
               * Example: For `[^1^][^1^]`
               * it will be split into parts: ['', '1', '', '1', ''],
               * This code will skip any rendering for the last empty string (index=4)
               * Because the empty string at index=2 already added 1 empty space from the code below
               */ if (isLastCitationDuplicate && part.trim() === '') return;
                        if (part.trim() !== '') /**
                 * if the text part is not an empty string, we want to reset the last citation
                 * because the text part is a valid text, and not a space between citations
                 * so that we can render citation again, even if the next number is the same as the last number
                 *
                 * Example:
                 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
                 */ lastCitation = null;
                        const textToken = new state.Token('text', '', 0);
                        if (index === parts.length - 1) textToken.content = part;
                        else textToken.content = part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        const citationToken = new state.Token('status', '', 0);
                        citationToken.content = '';
                        citationToken.block = false;
                        citationToken.level = childToken.level;
                        let citationText = part;
                        citationToken.attrs = [
                            [
                                'color',
                                'blue'
                            ],
                            [
                                'text',
                                citationText
                            ],
                            // localId is used to identify the citation token in the DOM
                            // this overrides the uuid that is normally used
                            [
                                'localId',
                                `citation-${citationText}`
                            ]
                        ];
                        citationToken.content = citationText;
                        newChildren.push(citationToken);
                    }
                });
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $eedc127a683be258$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $eedc127a683be258$var$citation);

});

parcelRegister("kVuPa", function(module, exports) {
$parcel$export(module.exports, "default", () => $85f34bd2edc9da4d$export$2e2bcd8739ae039);
const $85f34bd2edc9da4d$var$SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
const $85f34bd2edc9da4d$var$dataSculptor = (state)=>{
    const tokens = [];
    let sculptorCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $85f34bd2edc9da4d$var$SCULPTOR_REGEX.test(childToken.content)) {
                const citationToken = new state.Token('status', '', 0);
                citationToken.content = '';
                citationToken.block = false;
                citationToken.level = childToken.level;
                const parts = childToken.content.split($85f34bd2edc9da4d$var$SCULPTOR_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        citationToken.attrs = [
                            [
                                'localId',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'text',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(citationToken);
                        sculptorCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $85f34bd2edc9da4d$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('data-sculptor', $85f34bd2edc9da4d$var$dataSculptor);

});

parcelRegister("kbmYM", function(module, exports) {
const $8d6eacbf9e066d7e$var$EXPAND_REGEX = /\[\^(expand)\^\]/;
const $8d6eacbf9e066d7e$var$expandable = (state)=>{
    const tokens = [];
    let expandCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children?.length === 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $8d6eacbf9e066d7e$var$EXPAND_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($8d6eacbf9e066d7e$var$EXPAND_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const expandToken = new state.Token('status', '', 0);
                        expandToken.content = '';
                        expandToken.block = false;
                        expandToken.level = childToken.level;
                        expandToken.attrs = [
                            [
                                'localId',
                                'expandable-' + expandCounter
                            ],
                            [
                                'text',
                                'expandable-' + expandCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(expandToken);
                        expandCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
const $8d6eacbf9e066d7e$var$mdPluginExpandable = (md)=>{
    md.core.ruler.push('expandable', $8d6eacbf9e066d7e$var$expandable);
};
var $8d6eacbf9e066d7e$export$2e2bcd8739ae039 = $8d6eacbf9e066d7e$var$mdPluginExpandable;
module.exports["default"] = $8d6eacbf9e066d7e$export$2e2bcd8739ae039;

});

parcelRegister("ijO3G", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc4534e96af60336$export$2e2bcd8739ae039);
const $cc4534e96af60336$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $cc4534e96af60336$var$groupedCitations = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $cc4534e96af60336$var$CITATION_REGEX.test(childToken.content)) {
                /**
           * Example content: `Hello [^1^][^1^].`
           * `parts` will be ['Hello ', '1', '', '1', '.']
           */ const parts = childToken.content.split($cc4534e96af60336$var$CITATION_REGEX);
                const newChildren = [];
                /**
           * we want to remove consecutive citation
           * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
           * should be transformed to `Hello 1. How are you 1 2`
           */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                let citationIndices = [];
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
               * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
               * So it doesn't end up rendering empty space that will end up with multi empty spaces
               * because previous valid citation already added 1 empty space
               *
               * Example: For `[^1^][^1^]`
               * it will be split into parts: ['', '1', '', '1', ''],
               * This code will skip any rendering for the last empty string (index=4)
               * Because the empty string at index=2 already added 1 empty space from the code below
               */ if ((isLastCitationDuplicate || citationIndices.length > 0) && part.trim() === '') return;
                        if (part.trim() !== '') {
                            /**
                 * if the text part is not an empty string, we want to reset the last citation
                 * because the text part is a valid text, and not a space between citations
                 * so that we can render citation again, even if the next number is the same as the last number
                 *
                 * Example:
                 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
                 */ lastCitation = null;
                            /**
                 * once we reach a text part, we need to capture the indices of the citations that have occurred up to this point
                 *
                 * Example
                 * `Hello [^1^][^2^] The example continues` -> parts = ['Hello ', '1', '', '2', 'The example continues']
                 * When 'The example continues' is reached, we need to create a status token for the citations prior
                 */ if (citationIndices.length > 0) {
                                const citationToken = new state.Token('status', '', 0);
                                citationToken.content = '';
                                citationToken.block = false;
                                citationToken.level = childToken.level;
                                // localId is used to identify the citation indices in the DOM
                                // this overrides the uuid that is normally used
                                // NOTE: ReactRenderer expects specific props for status nodes and
                                // therefore we cannot pass in custom attributes
                                citationToken.attrs = [
                                    [
                                        'color',
                                        'blue'
                                    ],
                                    [
                                        'text',
                                        'citation'
                                    ],
                                    // citationIndices is used to identify the citation token in the DOM
                                    // this overrides the uuid that is normally used
                                    [
                                        'localId',
                                        JSON.stringify(citationIndices)
                                    ]
                                ];
                                newChildren.push(citationToken);
                                citationIndices = [];
                            }
                        }
                        const textToken = new state.Token('text', '', 0);
                        // don't add trailing space if part already ends with one
                        textToken.content = index === parts.length - 1 ? part : part.endsWith(' ') ? part : part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        if (part !== '') newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        citationIndices.push(parseInt(part));
                    }
                });
                /**
           * Once we've reached the end of parts, we need to create a status token for any citations at the very end
           *
           * Example: `Hello [^1^][^2^]` -> parts = ['Hello ', '1', '', '2', '']
           * When we've iterated through all of parts, 1 and 2 indices exist in citationIndices, and a status token needs to be created
           */ if (citationIndices.length > 0) {
                    const citationToken = new state.Token('status', '', 0);
                    citationToken.content = '';
                    citationToken.block = false;
                    citationToken.level = childToken.level;
                    citationToken.attrs = [
                        [
                            'color',
                            'blue'
                        ],
                        [
                            'text',
                            'citation'
                        ],
                        [
                            'localId',
                            JSON.stringify(citationIndices)
                        ]
                    ];
                    newChildren.push(citationToken);
                    citationIndices = [];
                }
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $cc4534e96af60336$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $cc4534e96af60336$var$groupedCitations);

});

parcelRegister("guSRW", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fbf901ea773181f$export$2e2bcd8739ae039);

var $7KWEi = parcelRequire("7KWEi");

const $2fbf901ea773181f$var$FOLLOW_UPS_REGEX = /\[\^(actionable-follow-ups)\^\]/;
/**
 * Replaces the `[^actionable-follow-ups^]` placeholder (injected when the `◈`
 * marker is extracted from the assistant response) with a `status` node whose
 * `localId`/`text` is prefixed with `ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX`. The
 * renderer swaps that status node for the actionable follow-up questions UI,
 * pulling the parsed questions from the message's `markdownData`.
 *
 * Mirrors `md-plugin-inline-lumina`.
 */ const $2fbf901ea773181f$var$inlineFollowUps = (state)=>{
    const tokens = [];
    let followUpsCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $2fbf901ea773181f$var$FOLLOW_UPS_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($2fbf901ea773181f$var$FOLLOW_UPS_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const followUpsToken = new state.Token('status', '', 0);
                        followUpsToken.content = '';
                        followUpsToken.block = false;
                        followUpsToken.level = childToken.level;
                        followUpsToken.attrs = [
                            [
                                'localId',
                                (0, $7KWEi.ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX) + followUpsCounter
                            ],
                            [
                                'text',
                                (0, $7KWEi.ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX) + followUpsCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(followUpsToken);
                        followUpsCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $2fbf901ea773181f$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('inline-follow-ups', $2fbf901ea773181f$var$inlineFollowUps);
}

});

parcelRegister("7KWEi", function(module, exports) {
/**
 * Actionable Follow-Up Questions parsing utilities.
 *
 * The backend appends a follow-up section to the end of an assistant answer using a
 * single section marker followed by prose with inline `<followup>…</followup>` tagged
 * questions interspersed:
 *
 *   Normal answer text...
 *
 *   ◈If you want I can <followup>Convert this to a FAQ</followup>, <followup>Add target personas</followup>, or <followup>Make the tone more formal</followup>
 *
 * There is no end marker — everything after the first `◈` is the follow-up payload and
 * is assumed to be the last thing in the message. The surrounding prose renders as
 * normal text, while each `<followup>…</followup>` renders as an inline clickable link.
 *
 * See LDR: https://hello.atlassian.net/wiki/spaces/AA6/pages/7164582669
 */ /** Section marker (U+25C8) that denotes the start of the follow-up questions payload. */ const $ec7ae552a33eceda$export$159e069055621f01 = "\u25C8";
const $ec7ae552a33eceda$export$3b3ac8a86d553ab4 = 'actionable-follow-ups-';
const $ec7ae552a33eceda$export$5b6a3157002ae3dc = (localId)=>{
    return localId != null && localId.startsWith($ec7ae552a33eceda$export$3b3ac8a86d553ab4);
};
/**
 * Matches each `<followup>…</followup>` segment in the follow-up payload. The inner capture
 * is non-greedy and allows any character (including `<`/`>`), so question text containing
 * angle brackets parses correctly. An unterminated `<followup>` with no closing tag simply
 * does not match and is treated as in-flight prose.
 */ const $ec7ae552a33eceda$var$FOLLOW_UP_QUESTION_REGEX = /<followup>([\s\S]*?)<\/followup>/g;
const $ec7ae552a33eceda$export$7111c271f22de367 = (payload)=>{
    if (!payload) return [];
    // Strip a leading marker if the caller passed the full section including `◈`.
    const markerIndex = payload.indexOf($ec7ae552a33eceda$export$159e069055621f01);
    let text = markerIndex === -1 ? payload : payload.slice(markerIndex + $ec7ae552a33eceda$export$159e069055621f01.length);
    // Drop an unterminated trailing `<followup>` fragment so a half-streamed question
    // is not rendered as raw text until its closing tag arrives.
    const lastOpen = text.lastIndexOf('<followup>');
    if (lastOpen !== -1 && text.indexOf('</followup>', lastOpen) === -1) text = text.slice(0, lastOpen);
    const segments = [];
    let lastIndex = 0;
    const pushText = (value)=>{
        if (value) segments.push({
            type: 'text',
            value: value
        });
    };
    for (const match of text.matchAll($ec7ae552a33eceda$var$FOLLOW_UP_QUESTION_REGEX)){
        const matchIndex = match.index ?? 0;
        // Prose preceding this question (preserved verbatim).
        pushText(text.slice(lastIndex, matchIndex));
        lastIndex = matchIndex + match[0].length;
        const question = match[1]?.trim();
        if (question) segments.push({
            type: 'question',
            value: question
        });
    }
    // Trailing prose after the final question.
    pushText(text.slice(lastIndex));
    return segments;
};
module.exports["ACTIONABLE_FOLLOW_UPS_MARKER"] = $ec7ae552a33eceda$export$159e069055621f01;
module.exports["ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX"] = $ec7ae552a33eceda$export$3b3ac8a86d553ab4;
module.exports["isActionableFollowUpsStatus"] = $ec7ae552a33eceda$export$5b6a3157002ae3dc;
module.exports["parseActionableFollowUps"] = $ec7ae552a33eceda$export$7111c271f22de367;

});

parcelRegister("eqo2H", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e69c75627933db8$export$2e2bcd8739ae039);

var $l8G7y = parcelRequire("l8G7y");

const $2e69c75627933db8$var$LUMINA_REGEX = /\[\^(lumina)\^\]/;
const $2e69c75627933db8$var$inlineLumina = (state)=>{
    const tokens = [];
    let luminaCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $2e69c75627933db8$var$LUMINA_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($2e69c75627933db8$var$LUMINA_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const luminaToken = new state.Token('status', '', 0);
                        luminaToken.content = '';
                        luminaToken.block = false;
                        luminaToken.level = childToken.level;
                        luminaToken.attrs = [
                            [
                                'localId',
                                (0, $l8G7y.INLINE_LUMINA_STATUS_PREFIX) + luminaCounter
                            ],
                            [
                                'text',
                                (0, $l8G7y.INLINE_LUMINA_STATUS_PREFIX) + luminaCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(luminaToken);
                        luminaCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $2e69c75627933db8$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('inline-lumina', $2e69c75627933db8$var$inlineLumina);
}

});

parcelRegister("l8G7y", function(module, exports) {
const $b441813f442be22d$export$8288860537fb7872 = 'inline-lumina-';
const $b441813f442be22d$export$5d9d37bd58628e00 = (localId)=>{
    return localId != null && localId.startsWith($b441813f442be22d$export$8288860537fb7872);
};
module.exports["INLINE_LUMINA_STATUS_PREFIX"] = $b441813f442be22d$export$8288860537fb7872;
module.exports["isInlineLuminaStatus"] = $b441813f442be22d$export$5d9d37bd58628e00;

});

parcelRegister("kiC47", function(module, exports) {

var $6RXI6 = parcelRequire("6RXI6");

const $0c4919c13452ed71$export$763ac077c9998026 = (params)=>(md)=>md.core.ruler.push('custom-linkify', (0, $6RXI6.createLinkify)(params));
module.exports["createLinkifyPlugin"] = $0c4919c13452ed71$export$763ac077c9998026;

});

parcelRegister("6RXI6", function(module, exports) {

var $2Gb84 = parcelRequire("2Gb84");


var $81OAa = parcelRequire("81OAa");

// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
const $146b6bae45423f24$var$arrayReplaceAt = (src, pos, newElements)=>[].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
const $146b6bae45423f24$var$isLinkOpen = (str)=>{
    return /^<a[>\s]/i.test(str);
};
const $146b6bae45423f24$var$isLinkClose = (str)=>{
    return /^<\/a\s*>/i.test(str);
};
const $146b6bae45423f24$export$8cd7d1ec2e6808da = ({ findFilepaths: findFilepaths, isLinkInMatches: isLinkInMatches })=>(state)=>{
        const blockTokens = state.tokens;
        const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
        for(let j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            let tokens = blockTokens[j].children ?? [];
            let htmlLinkLevel = 0;
            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for(let i = tokens.length - 1; i >= 0; i--){
                const currentToken = tokens[i];
                // Skip content of markdown links
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                // Skip content of html tag links
                if (currentToken.type === 'html_inline') {
                    if ($146b6bae45423f24$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($146b6bae45423f24$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    const text = currentToken.content;
                    let links = (0, $81OAa.linkifyMatch)(text);
                    if (!links.length) links = linkify.match(text) || [];
                    // Now split string to nodes
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const nodes = [];
                    let level = currentToken.level;
                    let lastPos = 0;
                    const filepaths = findFilepaths(text);
                    for(let ln = 0; ln < links.length; ln++){
                        if (isLinkInMatches(links[ln].index, filepaths)) continue;
                        const { url: url } = links[ln];
                        const fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        let urlText = links[ln].text;
                        // Linkifier might send raw hostnames like "example.com", where url
                        // starts with domain name. So we prepend http:// in those cases,
                        // and remove it afterwards.
                        //
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        const pos = links[ln].index;
                        if (pos > lastPos) {
                            const token = new state.Token('text', '', 0);
                            token.content = text.slice(lastPos, pos);
                            token.level = level;
                            nodes.push(token);
                        }
                        let token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < text.length) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos);
                        token.level = level;
                        nodes.push(token);
                    }
                    // replace current node
                    blockTokens[j].children = tokens = $146b6bae45423f24$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
module.exports["createLinkify"] = $146b6bae45423f24$export$8cd7d1ec2e6808da;

});

parcelRegister("b2Usv", function(module, exports) {
/**
 * This plugin handles blockquotes nested inside list items.
 * Since ADF doesn't support blockquotes as children of listItems,
 * we transform blockquote content into emphasized (italic) paragraphs.
 *
 * Before: 1. Item\n   > "Quote"
 * After:  1. Item\n   _"Quote"_
 *
 * This allows quotes within lists to render gracefully as italicized text
 * rather than failing due to ADF schema constraints.
 */ const $eebefa0fafefd79c$var$listBlockquoteFallback = (state)=>{
    const tokens = state.tokens;
    let listDepth = 0;
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Track list nesting depth
        if (token.type === 'ordered_list_open' || token.type === 'bullet_list_open') listDepth++;
        else if (token.type === 'ordered_list_close' || token.type === 'bullet_list_close') listDepth--;
        // If we're inside a list and encounter a blockquote, transform it
        if (listDepth > 0 && token.type === 'blockquote_open') {
            // Find the matching blockquote_close
            let closeIndex = -1;
            let depth = 1;
            for(let j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'blockquote_open') depth++;
                else if (tokens[j].type === 'blockquote_close') {
                    depth--;
                    if (depth === 0) {
                        closeIndex = j;
                        break;
                    }
                }
            }
            if (closeIndex !== -1) {
                // Mark the blockquote tokens for removal
                token.type = 'blockquote_fallback_open';
                token.hidden = true;
                tokens[closeIndex].type = 'blockquote_fallback_close';
                tokens[closeIndex].hidden = true;
                // Process the content inside the blockquote
                // We need to wrap the inline content with emphasis marks
                for(let j = i + 1; j < closeIndex; j++){
                    const innerToken = tokens[j];
                    if (innerToken.type === 'inline' && innerToken.children) {
                        // Wrap all children with em marks
                        const emOpen = new state.Token('em_open', 'em', 1);
                        emOpen.block = false;
                        const emClose = new state.Token('em_close', 'em', -1);
                        emClose.block = false;
                        innerToken.children = [
                            emOpen,
                            ...innerToken.children,
                            emClose
                        ];
                    }
                }
            }
        }
    }
    // Filter out the hidden blockquote fallback tokens
    state.tokens = tokens.filter((t)=>t.type !== 'blockquote_fallback_open' && t.type !== 'blockquote_fallback_close');
};
const $eebefa0fafefd79c$var$mdPluginListBlockquoteFallback = (md)=>{
    md.core.ruler.push('list_blockquote_fallback', $eebefa0fafefd79c$var$listBlockquoteFallback);
};
var $eebefa0fafefd79c$export$2e2bcd8739ae039 = $eebefa0fafefd79c$var$mdPluginListBlockquoteFallback;
module.exports["default"] = $eebefa0fafefd79c$export$2e2bcd8739ae039;

});

parcelRegister("3Jbpl", function(module, exports) {
$parcel$export(module.exports, "default", () => $536a5df99342df46$export$2e2bcd8739ae039);
/**
Note: This implementation was built by referencing Editor AI
packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/md/media-md-plugin.ts

Aside from a refactor, the key differences in logic are:
- Our regex is more specific, and will only match images that are not inside single backticks otherwise we'll see AI Mate render images surrounded by single backticks
*/ function $536a5df99342df46$var$createRule() {
    // Match any images that aren't inside single backticks
    const mdImageRegex = RegExp("(?<!`)!\\[[^\\]]*\\]\\([^\\)]+\\)(?!`)", "g");
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open'
    ];
    return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        // Track the difference between original array indices and accumulated tokens indices
        // This is needed because when we skip processed tokens, the indices diverge
        let indexOffset = 0;
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && mdImageRegex.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                // Loop backwards through the tokens until a valid parent token is found
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                // If the previous token is not a valid parent token, add it to the start of the opening tokens array
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                // Create closing tokens for each opening token and reverse the array
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                const matches = token.content.match(mdImageRegex);
                // Process all images in the inline token
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substring(0, start);
                    inlineContentStack = inlineContentStack.substring(start + match.length);
                    // Add the inline tokens and media tokens to the subtree
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                // If there is any remaining content in the stack, add the inline tokens to the subtree
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                // Adjust cursor to account for previously skipped/modified tokens
                const adjustedCursor = cursor - indexOffset;
                tokens = [
                    ...tokens.slice(0, adjustedCursor),
                    ...subTree
                ];
                // Update offset: we consumed (i - cursor + 1) original tokens and added subTree.length
                indexOffset += i + 1 - cursor - subTree.length;
            } else if (processedTokens.indexOf(token.type) !== -1) {
                // Ignore token if it's already processed
                processedTokens.splice(processedTokens.indexOf(token.type), 1);
                // We skipped a token, so the offset increases
                indexOffset++;
            } else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $536a5df99342df46$export$2e2bcd8739ae039 = (md)=>{
    md.core.ruler.before('inline', 'media', $536a5df99342df46$var$createRule());
};

});

parcelRegister("j0P3F", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab169cc784e6afd4$export$2e2bcd8739ae039);
// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
const $ab169cc784e6afd4$var$isPeopleLink = (url)=>{
    return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
const $ab169cc784e6afd4$var$getAccountId = (url)=>{
    const match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
    return match ? match[1] : null;
};
const $ab169cc784e6afd4$var$mentionLinks = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        // We're only looking for inline children
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken, i)=>{
            const url = childToken.attrGet('href') ?? '';
            const discardedToken = [
                'link_close',
                'text'
            ].includes(childToken.type) && [
                tokenChildren[i - 1]?.type,
                tokenChildren[i - 2]?.type
            ].includes('mention');
            // Discarded tokens are preserved as `null` so index
            // cross-referencing between processed and raw tokens may
            // be preserved, however null are filtered out later.
            if (discardedToken) {
                tokenChildren.push(null);
                return;
            }
            if (childToken.type === 'link_open' && $ab169cc784e6afd4$var$isPeopleLink(url)) {
                const mentionText = token.children?.[i + 1]?.content ?? '';
                let mentionToken = new state.Token('mention', '', 0);
                mentionToken.content = '';
                mentionToken.block = false;
                mentionToken.level = childToken.level;
                mentionToken.attrSet('id', `${$ab169cc784e6afd4$var$getAccountId(url)}`);
                if (mentionText) mentionToken.attrSet('text', `@${mentionText}`);
                tokenChildren.push(mentionToken);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $ab169cc784e6afd4$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('mention', $ab169cc784e6afd4$var$mentionLinks);

});

parcelRegister("dSj2z", function(module, exports) {

var $gEMk1 = parcelRequire("gEMk1");

const $d5cccf701aceb868$var$linkPatternStart = '\\bhttps?:\\/\\/(?:www\\.)?';
const $d5cccf701aceb868$var$linkPatternEnd = '[^\\s\\]\\)]*';
const $d5cccf701aceb868$var$linkRegex = {
    youtube: `${$d5cccf701aceb868$var$linkPatternStart}youtube\\.com${$d5cccf701aceb868$var$linkPatternEnd}`,
    youtubeShortUrl: `${$d5cccf701aceb868$var$linkPatternStart}youtu\\.be${$d5cccf701aceb868$var$linkPatternEnd}`,
    loomVideo: `${$d5cccf701aceb868$var$linkPatternStart}loom\\.com\\/share\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    figmaFile: `${$d5cccf701aceb868$var$linkPatternStart}figma\\.com\\/(file|design)\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    confluenceWhiteboard: `${$d5cccf701aceb868$var$linkPatternStart}.*\\/wiki\\/spaces\\/.*\\/whiteboard\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googlePresentationAndSpreadsheet: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/(presentation|spreadsheets)\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googleDoc: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/(document)\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googleForm: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/forms\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    microsoftForm: `${$d5cccf701aceb868$var$linkPatternStart}forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=${$d5cccf701aceb868$var$linkPatternEnd}`,
    // this will be removed following project
    analyticsChart: `\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-${$d5cccf701aceb868$var$linkPatternEnd}` // this will be removed following project
};
const $d5cccf701aceb868$var$newThirdPartyLinkRegex = {
    github: `${$d5cccf701aceb868$var$linkPatternStart}github\\.com${$d5cccf701aceb868$var$linkPatternEnd}`,
    canvaDesign: `${$d5cccf701aceb868$var$linkPatternStart}canva\\.com\\/design\\/[a-zA-Z0-9_\\-.]{1,255}\\/[a-zA-Z0-9_\\-.]{1,255}(?:\\/[^\\s\\]\\)]*)?`,
    canvaShortLink: `${$d5cccf701aceb868$var$linkPatternStart}canva\\.link\\/[a-zA-Z0-9]+(?:\\?${$d5cccf701aceb868$var$linkPatternEnd})?`,
    rovo: `${$d5cccf701aceb868$var$linkPatternStart}[^\\s\\]\\)]*\\.atlassian\\.net\\/rovo${$d5cccf701aceb868$var$linkPatternEnd}`,
    amplitude: `${$d5cccf701aceb868$var$linkPatternStart}app\\.amplitude\\.com${$d5cccf701aceb868$var$linkPatternEnd}`
};
const $d5cccf701aceb868$var$buildEmbedRegex = (includeNewThirdParties)=>{
    const patterns = [
        ...Object.values($d5cccf701aceb868$var$linkRegex),
        ...includeNewThirdParties ? Object.values($d5cccf701aceb868$var$newThirdPartyLinkRegex) : []
    ];
    return new RegExp(patterns.join('|'), 'g');
};
const $d5cccf701aceb868$var$embedInlineRegex = [
    // avpRovoSkillsChart
    `${$d5cccf701aceb868$var$linkPatternStart}avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+${$d5cccf701aceb868$var$linkPatternEnd}`
];
const $d5cccf701aceb868$var$avpChartsRegex = `${$d5cccf701aceb868$var$linkPatternStart}.*?\\/avpviz\\/c\\/[^\\/]+.*${$d5cccf701aceb868$var$linkPatternEnd}`;
/**
 * Checks if there is more than one link in the token stream.
 * Used to determine if all links should be rendered inline instead of as embeds.
 */ const $d5cccf701aceb868$var$hasMultipleLinks = (tokens)=>{
    let linkCount = 0;
    for (const token of tokens){
        if (token.type !== 'inline' || !token.children) continue;
        for (const childToken of token.children)if (childToken?.type === 'link_open') {
            linkCount++;
            if (linkCount > 1) return true; // Early exit once we find more than one
        }
    }
    return false;
};
const $d5cccf701aceb868$var$createSmartLinks = ({ regexStorage: regexStorage, isExperimentEnabled: isExperimentEnabled, shouldShowAsInline: shouldShowAsInline, xpcWrapUrl: xpcWrapUrl })=>(state)=>{
        const embedRegex = $d5cccf701aceb868$var$buildEmbedRegex(isExperimentEnabled?.('rovo_chat_smartlink_new_third_parties', false) ?? false);
        const tokens = [];
        const embedTokens = [];
        let embedMatches = [];
        let filteredTokens = [];
        const renderedInlineEmbeds = new Set();
        // If there are more than one link or the user opened the chat in mini modal, all links display inline
        const forceAllToInline = $d5cccf701aceb868$var$hasMultipleLinks(state.tokens) || shouldShowAsInline;
        // process each token to determine if the link should be converted to a smartlink
        for (const token of state.tokens){
            let processedTokenChildren = [];
            const regexMatchesRaw = token.content?.trim().match(embedRegex);
            const regexMatches = regexMatchesRaw ? Array.from(new Set(regexMatchesRaw)) : [];
            embedMatches = [
                ...embedMatches,
                ...regexMatches
            ];
            // Any block or embed Smart Card links will be in an "inline" token. If
            // the current token is anything other than "inline", or there's no child tokens
            // to process, then we add it to the list of tokens to keep and move forward
            if (token.type !== 'inline' || !token.children) {
                tokens.push(token);
                continue;
            }
            var outputToken = new state.Token('inline', '', 0);
            let tokensToAppend = [
                outputToken
            ];
            if (token.children) {
                let discardUntilIndex = -1;
                token.children.forEach((childToken, i)=>{
                    const discardedToken = i <= discardUntilIndex && [
                        'link_close',
                        'text'
                    ].includes(childToken.type);
                    if (discardedToken) return;
                    const url = childToken.attrGet('href') ?? '';
                    const isInlineLink = url === token.children?.[i + 1]?.content;
                    if (childToken?.type === 'link_open' && ((0, $gEMk1.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                        // Discard the next two tokens. We're now processing the opening node for a URL
                        // that will result in a new node that replaces it, therefore the subsequent link content and
                        // closing node are no longer needed
                        discardUntilIndex = i + 2;
                        // This link will be rendered as a smart link (embed or inline card) by the linking
                        // platform, so we only strip the `datasource` param without applying full XPC wrapping.
                        const smartLinkUrl = xpcWrapUrl ? xpcWrapUrl(url, true) : url;
                        // Check if this link should be rendered as an embed card inline (e.g., Loom, YouTube, Figma) at end of result
                        const matchesEmbedRegex = url.match(embedRegex);
                        if (matchesEmbedRegex && !embedMatches.includes(url)) embedMatches.push(url);
                        // handle condition for when link in the token content matches the linkRegex
                        const shouldRenderLinksAsEmbed = matchesEmbedRegex;
                        const shouldRenderAvpRovoSkillsEmbedInline = token.level <= 1 && $d5cccf701aceb868$var$embedInlineRegex.some((r)=>url.match(r));
                        const shouldRenderAvpChartsEmbedInline = token.level <= 1 && url.match($d5cccf701aceb868$var$avpChartsRegex);
                        const shouldRenderAvpEmbedInline = shouldRenderAvpRovoSkillsEmbedInline || shouldRenderAvpChartsEmbedInline;
                        // Render inline embed if either regex matches and token content is not part of a list
                        const shouldRenderEmbedInline = shouldRenderLinksAsEmbed && token.level <= 1;
                        if (shouldRenderAvpEmbedInline || shouldRenderLinksAsEmbed) {
                            // handle case if it is an analytic chart link or microsoft form link
                            // these should be rendered as inline cards, not embed cards
                            const isMicrosoftFormLink = new RegExp($d5cccf701aceb868$var$linkRegex.microsoftForm).test(url);
                            const isAnalyticsChartLink = new RegExp($d5cccf701aceb868$var$linkRegex.analyticsChart).test(url);
                            if (!forceAllToInline && shouldRenderEmbedInline && !isMicrosoftFormLink && !isAnalyticsChartLink || shouldRenderAvpEmbedInline) {
                                outputToken.children = processedTokenChildren;
                                tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                                // Capture whether the URL was standalone on its own line
                                // (i.e. there was no preceding text in the same paragraph)
                                const isStandaloneUrl = processedTokenChildren.length === 0;
                                processedTokenChildren = [];
                                let embedToken = new state.Token('embedCard', '', 0);
                                embedToken.content = '';
                                embedToken.block = true;
                                embedToken.attrSet('url', smartLinkUrl);
                                embedToken.attrSet('layout', 'center');
                                // Mark whether this embed came from a standalone-line URL
                                if (isStandaloneUrl && isExperimentEnabled?.('rovo_chat_smartlink_new_third_parties', false)) embedToken.attrSet('isStandalone', 'true');
                                tokensToAppend.push(embedToken);
                                tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                                outputToken = new state.Token('inline', '', 0);
                                tokensToAppend.push(outputToken);
                                // Track that we've rendered this URL as an inline embed
                                renderedInlineEmbeds.add(url);
                                return;
                            }
                        }
                        // create an inline card for the links that don't qualify
                        let cardToken = new state.Token('inlineCard', '', 0);
                        cardToken.content = '';
                        cardToken.block = false;
                        cardToken.level = childToken.level;
                        cardToken.attrSet('url', smartLinkUrl);
                        processedTokenChildren.push(cardToken);
                        return;
                    } else if (xpcWrapUrl && childToken?.type === 'link_open') // For plain links not supported by the linking platform, apply xpcWrapUrl (with full wrapping) to the href
                    childToken.attrSet('href', xpcWrapUrl(url, false));
                    // pushes non link tokens as is
                    processedTokenChildren.push(childToken);
                });
            }
            // set processed children to the output token
            outputToken.children = processedTokenChildren;
            // Keeps inline tokens that have children and all non-inline tokens.
            const blockTokensWithContent = tokensToAppend.filter((t)=>t.type !== 'inline' || t.children?.length);
            tokens.push(...blockTokensWithContent);
        }
        // Remove empty paragraphs otherwise add it to the filteredTokens
        for(let i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        state.tokens = [
            ...filteredTokens,
            ...embedTokens
        ];
        return;
    };
const $d5cccf701aceb868$export$9625a798761643ac = (params, isExperimentEnabled, shouldShowAsInline, xpcWrapUrl)=>(md)=>md.core.ruler.push('inlineCard', $d5cccf701aceb868$var$createSmartLinks({
            ...params,
            isExperimentEnabled: isExperimentEnabled,
            shouldShowAsInline: shouldShowAsInline,
            xpcWrapUrl: xpcWrapUrl
        }));
module.exports["createSmartLinksPlugin"] = $d5cccf701aceb868$export$9625a798761643ac;

});

parcelRegister("gEMk1", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $lBWya = parcelRequire("lBWya");

const $bf5d74ffdabdc3d2$export$4b1056d02426889c = (url, regexStorage)=>{
    const cachedProviderRegex = $bf5d74ffdabdc3d2$export$90caa0c170ea581(regexStorage);
    if (!cachedProviderRegex.length || !url.length) return false;
    try {
        const regexPattern = new RegExp(cachedProviderRegex, 'g');
        return regexPattern.test(url);
    } catch  {
        // Malformed joined provider regex (e.g. duplicate named capture groups) — treat as unsupported.
        return false;
    }
};
const $bf5d74ffdabdc3d2$export$90caa0c170ea581 = (regexStorage)=>{
    if (regexStorage.getItem((0, $lBWya.LS_PROVIDER_KEY))) return JSON.parse(`${regexStorage.getItem((0, $lBWya.LS_PROVIDER_KEY))}`);
    return '';
};
const $bf5d74ffdabdc3d2$export$5af966b3aa3b1d83 = (regexStorage, providerRegex)=>{
    regexStorage?.setItem((0, $lBWya.LS_PROVIDER_KEY), JSON.stringify(providerRegex));
};
const $bf5d74ffdabdc3d2$export$d08c351b3b4e4934 = async (regexStorage, baseUrl)=>{
    const providerData = await $bf5d74ffdabdc3d2$export$dfebbb511ada4128(baseUrl);
    if (providerData) {
        const providerRegex = $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a(providerData);
        $bf5d74ffdabdc3d2$export$5af966b3aa3b1d83(regexStorage, providerRegex);
        const providerMapping = $bf5d74ffdabdc3d2$export$8eafd18d19de7df5(providerData);
        $bf5d74ffdabdc3d2$export$b22dfe84603542b1(regexStorage, providerMapping);
    }
};
const $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return '';
    const sources = data.providers.reduce((acc, provider)=>{
        const providerSources = provider.patterns?.map((pattern)=>pattern.source) || [];
        return [
            ...acc,
            ...providerSources
        ];
    }, []);
    return sources.join('|');
};
const $bf5d74ffdabdc3d2$export$8eafd18d19de7df5 = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return {
        combinedRegex: '',
        patterns: []
    };
    const patterns = data.providers.flatMap((provider)=>(provider.patterns || []).map((pattern)=>({
                key: provider.key,
                regex: pattern.source
            })));
    const combinedRegex = patterns.map((p)=>p.regex).join('|');
    return {
        combinedRegex: combinedRegex,
        patterns: patterns
    };
};
const $bf5d74ffdabdc3d2$export$25b8a9cebf834f6e = (regexStorage)=>{
    const stored = regexStorage.getItem((0, $lBWya.LS_PROVIDER_MAPPING_KEY));
    if (stored) try {
        return JSON.parse(stored);
    } catch  {
        return null;
    }
    return null;
};
const $bf5d74ffdabdc3d2$export$b22dfe84603542b1 = (regexStorage, providerMapping)=>{
    regexStorage?.setItem((0, $lBWya.LS_PROVIDER_MAPPING_KEY), JSON.stringify(providerMapping));
};
const $bf5d74ffdabdc3d2$export$dfebbb511ada4128 = (0, $2XqLN.default)(async (baseUrl = '')=>{
    try {
        const response = await fetch(baseUrl + (0, $lBWya.PROVIDERS_API), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'resolve'
            })
        });
        const data = await response.json();
        return data || null;
    } catch  {
        return null;
    }
});
const $bf5d74ffdabdc3d2$export$ab8eaff0f2d596bd = (0, $2XqLN.default)(async (baseUrl = '')=>{
    const data = await $bf5d74ffdabdc3d2$export$dfebbb511ada4128(baseUrl);
    return data ? $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a(data) : '';
});
module.exports["isSupportedByLinkingPlatform"] = $bf5d74ffdabdc3d2$export$4b1056d02426889c;
module.exports["hydrateLinkingPlatformCache"] = $bf5d74ffdabdc3d2$export$d08c351b3b4e4934;

});

parcelRegister("lBWya", function(module, exports) {
const $9088146284880a5b$export$57ad190cdc563df3 = `/gateway/api/object-resolver/providers`;
const $9088146284880a5b$export$1a30f994aeced995 = `/gateway/api/object-resolver/resolve/batch`;
const $9088146284880a5b$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $9088146284880a5b$export$b9858121ed269ff3 = 'aiMateSmartLinkProviderMapping';
module.exports["PROVIDERS_API"] = $9088146284880a5b$export$57ad190cdc563df3;
module.exports["LS_PROVIDER_KEY"] = $9088146284880a5b$export$56bec2f197c16818;
module.exports["LS_PROVIDER_MAPPING_KEY"] = $9088146284880a5b$export$b9858121ed269ff3;

});

parcelRegister("1Ce64", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ff6b0f828ae5055$export$2e2bcd8739ae039);
const $9ff6b0f828ae5055$var$tableBreakTags = (state)=>{
    const tokens = state.tokens;
    // Find all table tokens
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Check if we're inside a table
        if (token.type === 'table_open') {
            // Process all tokens until the matching table_close
            let j = i + 1;
            while(j < tokens.length && tokens[j].type !== 'table_close'){
                // If we're in a table cell content
                if (tokens && tokens[j]?.type === 'inline' && tokens[j]?.children && tokens[j]?.children?.length) {
                    // Process the content of the cell
                    const children = tokens[j]?.children;
                    if (!children) continue;
                    for(let k = 0; k < children.length; k++){
                        const child = children[k];
                        if (!child) continue;
                        // Replace <br>, <br/>, and <br /> tags with newlines
                        // Match different variations of <br> tags
                        const brRegex = /<br\s*\/?>/gi;
                        if (brRegex.test(child.content)) {
                            child.content = child.content.replace(brRegex, '\n');
                            // If the content is now just a newline, change the token type
                            if (child.content === '\n') child.type = 'hardbreak';
                        }
                    }
                }
                j++;
            }
            // Skip to the end of the table
            i = j;
        }
    }
    return;
};
var $9ff6b0f828ae5055$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('table-break-tags', $9ff6b0f828ae5055$var$tableBreakTags);

});

parcelRegister("5XYXq", function(module, exports) {
$parcel$export(module.exports, "default", () => $28815f35966a9eaf$export$2e2bcd8739ae039);
const $28815f35966a9eaf$var$CHART_REGEX = /\[\^(chart)\^\]/;
const $28815f35966a9eaf$var$visualizationChart = (state)=>{
    const tokens = [];
    let chartCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $28815f35966a9eaf$var$CHART_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($28815f35966a9eaf$var$CHART_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        // Create a new token for each chart match
                        const chartToken = new state.Token('status', '', 0);
                        chartToken.content = '';
                        chartToken.block = false;
                        chartToken.level = childToken.level;
                        chartToken.attrs = [
                            [
                                'localId',
                                'chart-' + chartCounter
                            ],
                            [
                                'text',
                                'loading chart-' + chartCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(chartToken);
                        chartCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $28815f35966a9eaf$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('chart', $28815f35966a9eaf$var$visualizationChart);
}

});

parcelRegister("7ai6d", function(module, exports) {
const $a1a032ec05100051$export$cd54a56af01ba875 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $a1a032ec05100051$export$eb83d753215c78a2 = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        attrs: (tok)=>({
                state: tok.meta
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    code_inline: {
        mark: 'code'
    },
    ordered_list: {
        block: 'orderedList',
        attrs: (tok)=>{
            const order = +(tok.attrGet('start') || 1);
            return {
                order: order
            };
        }
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        attrs: (tok)=>({
                language: tok.info?.trim() || null
            })
    },
    image: {
        node: 'image',
        attrs: (_tok)=>{
            return {};
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                type: 'external'
            };
        }
    },
    // Enable ADF SmartLinks, produced by our SmartLink MD plugin
    inlineCard: {
        node: 'inlineCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    blockCard: {
        node: 'blockCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    embedCard: {
        node: 'embedCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
    mention: {
        node: 'mention',
        attrs: (tok)=>{
            return {
                id: tok.attrGet('id'),
                text: tok.attrGet('text'),
                type: 'mention'
            };
        }
    },
    status: {
        node: 'status',
        attrs: (token)=>({
                text: token.attrGet('text'),
                color: token.attrGet('color'),
                localId: token.attrGet('localId')
            })
    }
};
module.exports["pmToMd"] = $a1a032ec05100051$export$cd54a56af01ba875;
module.exports["mdToPmSchema"] = $a1a032ec05100051$export$eb83d753215c78a2;

});

parcelRegister("EZ3q4", function(module, exports) {
/**
 * Sanitizes raw markdown content before it reaches the markdown-it block tokenizer.
 *
 * Two constructs cause `ParserBlock.prototype.tokenize` to enter catastrophic
 * backtracking / exponential rule-matching, causing OOM browser crashes:
 *
 * ## 1. Tables indented 2+ spaces (inside a list item)
 *
 * The `markdown-it-table` plugin requires the table header row to start at
 * column 0 (or ≤1 space of indentation). When an AI response places a table
 * inside a list item — a common pattern — the table rows are indented with
 * 2+ spaces and are never recognized as a table block.
 *
 * Instead, each `|---` separator row triggers markdown-it's `lheading`
 * (setext heading) rule which checks whether the preceding paragraph can be
 * promoted to a heading. This check is O(n) against all prior paragraphs,
 * repeated for every `|` row in the table → O(n²) overall. For documents
 * with 200+ lines and multiple tables, this crashes the browser.
 *
 * ## 2. Code fences indented 4+ spaces (inside nested list items)
 *
 * markdown-it's `fence` block rule only recognizes fences with 0–3 spaces of
 * leading indentation. Fences indented with 4+ spaces (common inside nested
 * list items like "     ```jql") are treated as indented code continuation,
 * meaning the opening fence is never paired with its closing fence. The block
 * parser then tries every rule against the remaining content until EOF →
 * effectively infinite loop → OOM.
 *
 * ## Fix
 *
 * Strip excess leading whitespace from table rows and fence delimiters so
 * they are recognized by the parser as valid block-level constructs. A
 * fence-tracking state machine ensures that table rows and fence delimiters
 * *inside* a code fence are never modified.
 */ // Fast pre-check: matches a line starting with 2+ spaces followed by `|` or ` ``` `.
// Uses (^|\n) so it also catches indented constructs on the very first line.
// If the content has neither, skip the full line-by-line pass entirely.
const $603f9fbe0d7d63e0$var$NEEDS_SANITIZE_RE = /(?:^|\n) {2,}[|`]/;
function $603f9fbe0d7d63e0$export$20209a1e2cc01cc1(content) {
    if (!$603f9fbe0d7d63e0$var$NEEDS_SANITIZE_RE.test(content)) return content;
    const lines = content.split('\n');
    const result = [];
    let inFence = false;
    let fenceIndent = 0;
    for (const line of lines){
        const stripped = line.replace(/^\s+/, '');
        const indent = line.length - stripped.length;
        if (!inFence && stripped.startsWith('```')) {
            if (indent >= 4) {
                // Outdent deeply-indented opening fence to column 0 so the parser
                // recognizes it as a fenced code block
                result.push(stripped);
                inFence = true;
                fenceIndent = indent;
            } else {
                result.push(line);
                inFence = true;
                fenceIndent = indent;
            }
        } else if (inFence && stripped.startsWith('```')) {
            if (indent >= 4 && fenceIndent >= 4) // Outdent matching closing fence
            result.push(stripped);
            else result.push(line);
            inFence = false;
            fenceIndent = 0;
        } else if (!inFence && indent >= 2 && stripped.startsWith('|')) // Outdent table rows that are indented inside list items so
        // markdown-it-table recognizes them as a proper table block
        result.push(stripped);
        else result.push(line);
    }
    return result.join('\n');
}
module.exports["sanitizeMarkdown"] = $603f9fbe0d7d63e0$export$20209a1e2cc01cc1;

});

parcelRegister("bCKHR", function(module, exports) {

var $7ai6d = parcelRequire("7ai6d");

const $8bba972fb5d34921$export$155749302793c60c = (schema, map)=>Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
const $8bba972fb5d34921$export$a1cf9d9b96e16789 = (md, schema)=>{
    for(const k in 0, $7ai6d.pmToMd){
        const key = k;
        for(const i in (0, $7ai6d.pmToMd)[key]){
            const idx = i;
            if (schema[key][idx]) md.enable((0, $7ai6d.pmToMd)[key][idx]);
        }
    }
};
module.exports["filterSchemaMapping"] = $8bba972fb5d34921$export$155749302793c60c;
module.exports["enableSchemaPlugins"] = $8bba972fb5d34921$export$a1cf9d9b96e16789;

});

parcelRegister("cBi7Q", function(module, exports) {
const $a428bcb8f1a15d17$export$4b225aae27e9366b = '45c9c029-3180-4960-ab0d-db7cdeaf5f54';
const $a428bcb8f1a15d17$export$c87b1e2e3344192f = 1000;
const $a428bcb8f1a15d17$export$c4e7b6208a0b853e = 60;
const $a428bcb8f1a15d17$export$cd6b7e688e614eeb = $a428bcb8f1a15d17$export$c4e7b6208a0b853e * 60;
const $a428bcb8f1a15d17$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $a428bcb8f1a15d17$export$a0d33d6e93abfb90 = 'aiMateChatLoadPreference';
const $a428bcb8f1a15d17$export$e8114853eca81277 = 'ai-mate';
const $a428bcb8f1a15d17$export$45d167a0ef5aef8d = '/gateway/api/directory/graphql';
const $a428bcb8f1a15d17$export$1ea9613e3e37d315 = 30 * $a428bcb8f1a15d17$export$c4e7b6208a0b853e * $a428bcb8f1a15d17$export$c87b1e2e3344192f;
const $a428bcb8f1a15d17$export$501af059da333e01 = 5 * $a428bcb8f1a15d17$export$c4e7b6208a0b853e * $a428bcb8f1a15d17$export$c87b1e2e3344192f;
const $a428bcb8f1a15d17$export$f8d883b8f9181b19 = 'rovoChatLastMessageSentAt';
const $a428bcb8f1a15d17$export$d4e191820de5cb9e = 'ai_mate_agent';
const $a428bcb8f1a15d17$export$cf40b355c500b3f7 = 'f3a534d9-1498-e0d4-8b50-e058a8fb8156';
const $a428bcb8f1a15d17$export$85d90d98449e85fd = 140;
const $a428bcb8f1a15d17$export$cad0f6e78cd99203 = '600px';
const $a428bcb8f1a15d17$export$73f6568f4f3fdeda = 380;
const $a428bcb8f1a15d17$export$2c094f7f70c376e3 = 480;
const $a428bcb8f1a15d17$export$2e9abc2f500a1704 = 280;
module.exports["FEEDBACK_COLLECTOR_ENTRYPOINT_ID"] = $a428bcb8f1a15d17$export$4b225aae27e9366b;
module.exports["MS_IN_SECOND"] = $a428bcb8f1a15d17$export$c87b1e2e3344192f;
module.exports["SECONDS_IN_HR"] = $a428bcb8f1a15d17$export$cd6b7e688e614eeb;
module.exports["LS_CHAT_LOAD_PREFERENCE_KEY"] = $a428bcb8f1a15d17$export$a0d33d6e93abfb90;
module.exports["AI_MATE_EXPERIENCE_ID"] = $a428bcb8f1a15d17$export$e8114853eca81277;
module.exports["SHORTER_TIMEOUT_BEFORE_NEW_CHAT"] = $a428bcb8f1a15d17$export$501af059da333e01;
module.exports["LS_LAST_MESSAGE_SENT_AT"] = $a428bcb8f1a15d17$export$f8d883b8f9181b19;
module.exports["DEFAULT_AGENT_NAMED_ID"] = $a428bcb8f1a15d17$export$d4e191820de5cb9e;
module.exports["DEFAULT_AGENT_UUID"] = $a428bcb8f1a15d17$export$cf40b355c500b3f7;
module.exports["MINI_MODAL_GREETING_HEIGHT"] = $a428bcb8f1a15d17$export$85d90d98449e85fd;
module.exports["MINI_MODAL_EXPANDED_HEIGHT"] = $a428bcb8f1a15d17$export$cad0f6e78cd99203;
module.exports["SPLIT_LAYOUT_INITIAL_WIDTH"] = $a428bcb8f1a15d17$export$73f6568f4f3fdeda;
module.exports["SPLIT_LAYOUT_MIN_WIDTH"] = $a428bcb8f1a15d17$export$2c094f7f70c376e3;
module.exports["SPLIT_LAYOUT_ADJACENT_MIN_WIDTH"] = $a428bcb8f1a15d17$export$2e9abc2f500a1704;

});

parcelRegister("6eZqW", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8m4tT = parcelRequire("8m4tT");


var $8nxxM = parcelRequire("8nxxM");


var $2htg1 = parcelRequire("2htg1");

/**
 * If the first node is a paragraph we need to wrap it in a paragraph node for the markdown conversion to work properly
 */ function $fb0b992a34319cb0$var$createTextWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $8m4tT.findParentNodeClosestToPos)($from, (node)=>{
        return node.type.name === 'paragraph' || node.type.name === 'heading';
    })?.node;
    if (parent) return schema.nodes.doc.createChecked(null, schema.nodes[parent.type.name].createChecked(parent.attrs, fragment));
    else // If the node is a paragraph we need the parent to be a doc for the conversion to work correctly
    return schema.nodes.doc.createChecked(null, schema.nodes.paragraph.createChecked(null, fragment));
}
/**
 * This finds the closest list item parent to the current selection
 * Once found it will create a new list with the current fragment as its children
 */ function $fb0b992a34319cb0$var$createListItemWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $8m4tT.findParentNodeClosestToPos)($from, (node)=>node.type.name === 'bulletList' || node.type.name === 'orderedList')?.node;
    if (parent) return schema.nodes[parent.type.name].createChecked(parent.attrs, fragment);
    return fragment;
}
/**
 * If the first node is a task item we need to wrap it in a task list node for the markdown conversion to work properly
 */ function $fb0b992a34319cb0$var$createTaskItemWrapper(schema, fragment) {
    return schema.nodes.doc.createChecked(null, schema.nodes.taskList.createChecked(null, fragment));
}
function $fb0b992a34319cb0$var$createLayoutColumnWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const parentSection = (0, $8m4tT.findParentNodeOfType)(schema.nodes.layoutSection)(editorView.state.selection);
    if (parentSection) // Needs to be a doc for the serializer to work as it
    // loops through the fragments children to render
    return schema.nodes.doc.createChecked(null, schema.nodes.layoutSection.createChecked(parentSection.node.attrs, fragment));
    return fragment;
}
/**
 * This function handles partial selections and it will fix any incomplete fragments that won't be converted properly
 * If you do a partial selection, it will not select the parent node of certain nodes text, listItems etc so once it hits the serializer
 * the serializer will just fallback to plain text and not convert the node properly.
 *
 * This function checks the first child of the current selection, if its a node that needs a parent it will find the closest parent
 * and create a new fragment that will be converted properly by the serializer
 */ function $fb0b992a34319cb0$var$checkFragment(editorView, schema, fragment) {
    switch(fragment?.firstChild?.type?.name){
        case 'text':
            return $fb0b992a34319cb0$var$createTextWrapper(editorView, fragment);
        case 'listItem':
            return $fb0b992a34319cb0$var$createListItemWrapper(editorView, fragment);
        case 'taskItem':
            return $fb0b992a34319cb0$var$createTaskItemWrapper(schema, fragment);
        case 'layoutColumn':
            return $fb0b992a34319cb0$var$createLayoutColumnWrapper(editorView, fragment);
        default:
            return fragment;
    }
}
function $fb0b992a34319cb0$export$cc6cac500a4da966({ editorView: editorView, fragment: fragment, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    fragment = $fb0b992a34319cb0$var$checkFragment(editorView, editorView.state.schema, fragment);
    return $fb0b992a34319cb0$export$3d24004275aefeab({
        node: fragment,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
}
function $fb0b992a34319cb0$export$3d24004275aefeab({ node: node, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    const markdownSerializerState = new (0, $2htg1.MarkdownSerializerState)(featureToggles, mentionMap, idMap);
    markdownSerializerState.renderContent(node);
    const pmStats = new (0, $8nxxM.ProseMirrorContentStatistics)(node);
    const contentStatistics = pmStats.collectStatistics();
    const markdown = markdownSerializerState.out === '\u200c' ? '' : markdownSerializerState.out;
    return {
        markdown: markdown,
        fallbackState: markdownSerializerState.fallbackState,
        nonErrorFallbackState: markdownSerializerState.nonErrorFallbackState,
        idMap: markdownSerializerState.idMap,
        contentStatistics: contentStatistics
    };
}
module.exports["convertProsemirrorToMarkdown"] = $fb0b992a34319cb0$export$cc6cac500a4da966;
module.exports["convertProsemirrorNodeToMarkdown"] = $fb0b992a34319cb0$export$3d24004275aefeab;

});

parcelRegister("8nxxM", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

class $13b081699855d8a3$export$acf14785d7d5b1be {
    /**
   * Calculate statistics for the ProseMirror content such as node counts, mark counts and total character count.
   */ collectStatistics() {
        const { nodeCounts: nodeCounts, markCounts: markCounts, linksCount: linksCount, mentionsCount: mentionsCount } = this.countNodesAndMarks();
        const { totalCharacterCount: totalCharacterCount } = this.calculateCharacterCounts();
        return {
            nodeCounts: nodeCounts,
            markCounts: markCounts,
            linksCount: linksCount,
            mentionsCount: mentionsCount,
            totalCharacterCount: totalCharacterCount,
            contextSelectionScope: undefined
        };
    }
    countNodesAndMarks() {
        const nodeCounts = new Map();
        const markCounts = new Map();
        let linksCount = 0;
        let mentionsCount = 0;
        this.content.descendants((node)=>{
            nodeCounts.set(node.type.name, (nodeCounts.get(node.type.name) || 0) + 1);
            const marks = node.marks;
            marks.forEach((mark)=>{
                markCounts.set(mark.type.name, (markCounts.get(mark.type.name) || 0) + 1);
            });
            const { nodes: { inlineCard: inlineCard, mention: mention }, marks: { link: link } } = node.type.schema;
            if (node.type === mention) mentionsCount++;
            if (node.type === inlineCard && node.attrs.url) linksCount++;
            if (marks.find((mark)=>mark.type === link)) linksCount++;
        });
        return {
            nodeCounts: Object.fromEntries(nodeCounts),
            markCounts: Object.fromEntries(markCounts),
            linksCount: linksCount,
            mentionsCount: mentionsCount
        };
    }
    calculateCharacterCounts() {
        let allTextContent = '';
        if (this.content instanceof (0, $5SAOw.Node)) allTextContent = this.content.textContent;
        else this.content.forEach((child)=>{
            allTextContent += child.textContent;
        });
        return {
            totalCharacterCount: allTextContent.length
        };
    }
    constructor(content){
        this.content = void 0;
        this.content = content;
    }
}
module.exports["ProseMirrorContentStatistics"] = $13b081699855d8a3$export$acf14785d7d5b1be;

});

parcelRegister("2htg1", function(module, exports) {

var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");


var $2xv4m = parcelRequire("2xv4m");


var $bd943 = parcelRequire("bd943");


var $50zV1 = parcelRequire("50zV1");


var $8q1Q5 = parcelRequire("8q1Q5");

const $e985dce6263f3bba$export$1c401dbe379e8c65 = (()=>{
    function getMaxLength(text) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const matches = text.match(/`+/g) || [];
        return matches.reduce((prev, val)=>val.length > prev.length ? val : prev, '').length;
    }
    return function(text, minLength = 1) {
        const length = Math.max(minLength, getMaxLength(text) + 1);
        return (0, $8q1Q5.stringRepeat)('`', length);
    };
})();
class $e985dce6263f3bba$export$61055fa707e69319 extends (0, $42JDa.MarkdownSerializerState) {
    /**
   *
   * @param state: MarkdownSerializerState
   * @param targetType: string
   * @param targetAttributes: Record<string, unknown>
   * @returns id of the state if the state is found in the idMap, otherwise returns null
   */ findStateIdMap(state, targetType, targetAttributes) {
        // eslint-disable-next-line guard-for-in
        for(const key in state.idMap){
            const { type: type, attributes: attributes } = state.idMap[key];
            // Check type first for early exit
            if (type !== targetType) continue;
            // Check if attributes match
            let attributesMatch = true;
            for(const attrKey in targetAttributes)// localId is a special attribute that is used to identify the node in the markdown and should be ignored on match
            if (attrKey !== 'localId' && targetAttributes[attrKey] !== attributes[attrKey]) {
                attributesMatch = false;
                break; // No need to check other attributes
            }
            if (attributesMatch) return key;
        }
        return null;
    }
    /**
   *
   * @param state: MarkdownSerializerState
   * @param type: string
   * @param attributes: Record<string, unknown>
   * @returns `id-[id]idMap` if the id is not found in the state
   */ getIdBasedOnIdMap(state, type, attributes) {
        const id = state.findStateIdMap(state, type, attributes);
        if (id) return id;
        return `id-${state.idCounter++}`;
    }
    updateFallbackState(error, child) {
        if (error instanceof Error) {
            const childTypeName = child.type.name;
            const errorMessage = error.message;
            const childFallbackState = this.fallbackState?.[childTypeName];
            Object.assign(this.fallbackState, {
                [childTypeName]: {
                    ...childFallbackState,
                    [errorMessage]: (childFallbackState?.[errorMessage] || 0) + 1
                }
            });
        } else throw error;
    }
    updateNonErrorFallbackState(node) {
        Object.assign(this.nonErrorFallbackState, {
            [node.type.name]: (this.nonErrorFallbackState[node.type.name] || 0) + 1
        });
    }
    /**
   * Defines the internal atBlank method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L241
   */ atBlank() {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return /(^|\n)$/.test(this.out);
    }
    /**
   * Defines the internal flushClose method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L202
   */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += '\n';
            if (size > 1) {
                let delimMin = this.delim;
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + '\n';
            }
            this.closed = null;
        }
    }
    /**
   * This method overide adds support for "options"
   * options is an object that can be used to pass additional information to the node serializer
   *
   * This is useful when a grandparent node has information that needs to be passed to a grandchild node
   *
   * For example, a table node has information about whether or not the table has a header row
   * This information needs to be passed to the tableRow and tableCell node serializers so that it can render the correct markdown
   * @see MarkdownSerializerState.render()
   */ render(node, parent, index, options) {
        if (!this.nodes[node.type.name]) throw new Error(`Token type \`${node.type.name}\` not supported by Markdown renderer`);
        if (options?.skipFallback) this.nodes[node.type.name].serialize({
            state: this,
            node: node,
            parent: parent,
            index: index,
            options: options
        });
        else try {
            this.nodes[node.type.name].serialize({
                state: this,
                node: node,
                parent: parent,
                index: index,
                options: options
            });
        } catch (error) {
            this.updateFallbackState(error, node);
            return this.nodes.fallback.serialize({
                state: this,
                node: node,
                parent: parent,
                index: index
            });
        }
    }
    renderContent(parent) {
        parent.forEach((child, _offset, index)=>{
            if (// If child is an empty Textblock we need to insert a zwnj-character in order to preserve that line in markdown
            child.isTextblock && !child.textContent && // If child is a Codeblock we need to handle this separately as we want to preserve empty code blocks
            !(child.type.name === 'codeBlock') && !(child.content && child.content.size > 0)) return this.nodes.empty_line.serialize({
                state: this,
                node: child,
                parent: parent,
                index: index
            });
            try {
                return this.render(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
                return this.nodes.fallback.serialize({
                    state: this,
                    node: child,
                    parent: parent,
                    index: index
                });
            }
        });
    }
    /**
   * This method override will properly escape backticks in text nodes with "code" mark enabled.
   * Bitbucket uses python-markdown which does not honor escaped backtick escape sequences \`
   * inside a backtick fence.
   *
   * @see MarkdownSerializerState.renderInline()
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderInline(parent, options) {
        const active = [];
        let trailing = '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const progress = (node, _, index)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let marks = node ? node.marks.filter((mark)=>this.marks[mark.type.name]) : [];
            let leading = trailing;
            trailing = '';
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const info = this.marks[mark.type.name];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return info && info.expelEnclosingWhitespace;
            })) {
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp, @typescript-eslint/no-non-null-assertion
                const [, lead, inner, trail] = /^(\s*)(.*?)(\s*)$/m.exec(node.text);
                leading += lead;
                trailing = trail;
                if (lead || trail) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    node = inner ? node.withText(inner) : null;
                    if (!node) marks = active;
                }
            }
            const code = marks.length && marks[marks.length - 1].type.name === 'code' && marks[marks.length - 1];
            const len = marks.length - (code ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            // eslint-disable-next-line no-labels
            outer: for(let i = 0; i < len; i++){
                const mark = marks[i];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (!this.marks[mark.type.name].mixable) break;
                for(let j = 0; j < active.length; j++){
                    const other = active[j];
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (!this.marks[other.type.name].mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            while(active.length < len){
                const add = marks[active.length];
                active.push(add);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.text(this.markString(add, true, parent, index), false);
            }
            if (node) {
                if (!code || !node.isText) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.render(node, parent, index);
                else if (node.text) {
                    // Generate valid monospace, fenced with series of backticks longer that backtick series inside it.
                    let text = node.text;
                    const backticks = $e985dce6263f3bba$export$1c401dbe379e8c65(node.text, 1);
                    // Make sure there is a space between fences, otherwise python-markdown renderer will get confused
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    if (text.match(/^`/)) text = ' ' + text;
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    if (text.match(/`$/)) text += ' ';
                    this.text(backticks + text + backticks, false);
                }
            }
        };
        parent.forEach((child, _offset, index)=>{
            if (options?.skipFallback) progress(child, parent, index);
            else try {
                progress(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
            }
        });
        progress(null);
    }
    addBlockMarks(state, node, renderFunction) {
        const closingTags = [];
        // This is temporary, only adding the marks that we support, once we get full support this will be removed
        const markFilters = [
            'alignment',
            'breakout',
            'border'
        ];
        const marks = node.marks.filter((mark)=>markFilters.includes(mark.type.name));
        if (marks.length === 0) {
            renderFunction();
            return;
        }
        marks.forEach((mark)=>{
            const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, mark.type.name, mark.attrs) : `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: mark.type.name,
                attributes: mark.attrs
            };
            state.write(`<custom data-type="${mark.type.name}_open" data-id="${id}" />\n\n`);
            closingTags.unshift(`<custom data-type="${mark.type.name}_close" />\n\n`);
        });
        renderFunction();
        state.write(closingTags.join(''));
    }
    constructor(featureToggles, mentionMap, idMap){
        // @ts-ignore -next-line
        super($e985dce6263f3bba$export$695720b7e7a61533, $e985dce6263f3bba$export$3a8025f2f3e0c64, {});
        // ignoring as generated types for node serializer is inaccurate
        // parent and index in node serializers should be optional
        // Typing this as a string -- to override the PMMarkdownSerializerState type of any
        // In the confluence build -- this results in the out property being set to undefined in the constructor
        // whereas in the dev server this is stripped when the code is transpiled.
        // When it is used in transpilation -- "undefined" is added to the start of the generated text
        // out: string;
        this.idMap = {};
        this.idCounter = 0;
        this.nodes = void 0;
        this.marks = void 0;
        this.featureToggles = {};
        this.mentionMap = {};
        /**
     * Defines the internal variables used in the markdown serializer
     * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L172
     */ this.delim = '';
        this.out = '';
        this.closed = null;
        /**
     * This is used to track the number of times a node has failed to render
     * This is useful for debugging purposes
     * - the key is the node type name
     * - the value is an object with
     *   - the error message as the key
     *   - and the number of times it has failed to render with that message as the value.
     */ this.fallbackState = {};
        /**
     * This is used to track the number of times a node has rendered
     * but has not completely converted to markdown
     * For example: Tables are supported in markdown, however we currently do not have full support
     * So we fallback to the simplest version of the node that our serializer can support
     */ this.nonErrorFallbackState = {};
        this.context = {
            insideTable: false
        };
        this.nodes = $e985dce6263f3bba$export$695720b7e7a61533;
        this.marks = $e985dce6263f3bba$export$3a8025f2f3e0c64;
        this.featureToggles = featureToggles || {};
        this.mentionMap = mentionMap || {};
        this.idMap = idMap || {};
        this.idCounter = Object.keys(this.idMap).length;
    }
}
const $e985dce6263f3bba$var$editorNodes = {
    blockquote: {
        serialize ({ state: state, node: node }) {
            state.wrapBlock('> ', null, node, ()=>state.renderContent(node));
        },
        support: 'full'
    },
    codeBlock: {
        serialize ({ state: state, node: node }) {
            const backticks = $e985dce6263f3bba$export$1c401dbe379e8c65(node.textContent, 3);
            state.write(backticks + (node.attrs.language || '') + '\n');
            state.text(node.textContent ? node.textContent : '\u200c', false);
            state.ensureNewLine();
            state.write(backticks);
            state.closeBlock(node);
        },
        support: 'full'
    },
    heading: {
        serialize ({ state: state, node: node }) {
            state.write(state.repeat('#', node.attrs.level) + ' ');
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    rule: {
        serialize ({ state: state, node: node }) {
            state.write(node.attrs.markup || '---');
            state.closeBlock(node);
        },
        support: 'full'
    },
    bulletList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    orderedList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    listItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const order = (0, $50zV1.getOrderFromMaybeOrderedListNode)(parent);
            const delimiter = parent.type.name === 'bulletList' ? '* ' : `${order + index}. `;
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                // if at second child or more of list item, add a newline
                if (i > 0) state.write('\n');
                // if at first child of list item, add delimiter (e.g "1.").
                // if at second child or more of list item, only add spacing (not delimiter)
                if (i === 0) state.wrapBlock('  ', delimiter, node, ()=>state.render(child, parent, i));
                else state.wrapBlock('    ', null, node, ()=>state.render(child, parent, i));
                if (child.type.name === 'paragraph' && i > 0) state.write('\n');
                state.flushClose(1);
            }
            // if we're at the final list item, add a final closing newline
            if (index === parent.childCount - 1) state.write('\n');
        },
        support: 'full'
    },
    taskList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
                state.write('\n');
            }
            state.write('\n');
        },
        support: 'full'
    },
    taskItem: {
        serialize ({ state: state, node: node }) {
            const taskItemState = node.attrs.state;
            state.write(taskItemState === 'TODO' ? '- [ ] ' : '- [x] ');
            state.renderInline(node);
        },
        support: 'full'
    },
    paragraph: {
        serialize ({ state: state, node: node }) {
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    mediaGroup: {
        serialize ({ state: state, node: node }) {
            state.updateNonErrorFallbackState(node);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'fallback'
    },
    mediaInline: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaInline',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="mediaInline" data-id="${id}"></custom>`);
            });
        },
        support: 'preview'
    },
    mediaSingle: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mediaSingle', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaSingle',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="media_single_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="media_single_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                /**
         * Currently, if the parent is a node we assume that mediaSingle is nested (e.g. inside a
         * table or list). In these cases we only output \n as there is often already new lines added
         * by the parent node.
         * Otherwise, if mediaSingle is not nested we add an extra new line.
         */ if (parent instanceof (0, $5SAOw.Node)) state.write('\n');
                else state.write('\n\n');
            }
        },
        support: 'preview'
    },
    caption: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'caption', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'caption',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="caption_open" data-id="${id}" />\n\n`);
                try {
                    state.renderInline(node, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback.serialize({
                        state: state,
                        node: node,
                        parent: parent,
                        index: index
                    });
                }
                // captions do not contain paragraphs, so we need to add a newline after the content
                state.write(`\n\n<custom data-type="caption_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                state.write(node.textContent);
            }
        },
        support: 'preview'
    },
    media: {
        serialize ({ state: state, node: node }) {
            // Creating this fake URl allows us to pass the media attributes to the markdown without using markdown plus
            // Which allows image retention when using rovo since it doesn't support markdown plus
            const baseUrl = `blob:${(0, $bd943.MEDIA_BASE_URL_STAGING)}/?`;
            const queryString = Object.entries(node.attrs).map(([key, value])=>key !== 'alt' ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : ``).join('&');
            const fakeUrl = `${baseUrl}${queryString}`;
            state.write(`![](${fakeUrl})${state.featureToggles.markdownPlusAddComplexNodes ? '\n\n' : ''}`);
        },
        support: 'full'
    },
    image: {
        serialize ({ state: state, node: node }) {
            // Note: the 'title' is not escaped in this flavor of markdown.
            state.write('![' + (0, $8q1Q5.escapeMarkdown)(node.attrs.alt) + '](' + node.attrs.src + (node.attrs.title ? ` '${(0, $8q1Q5.escapeMarkdown)(node.attrs.title)}'` : '') + ')');
        },
        support: 'full'
    },
    hardBreak: {
        serialize ({ state: state }) {
            state.write('  \n');
        },
        support: 'full'
    },
    text: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const previousNode = index === 0 ? null : parent.child(index - 1);
            let text = node.textContent;
            // BB converts 4 spaces at the beginning of the line to code block
            // that's why we escape 4 spaces with zero-width-non-joiner
            const fourSpaces = '    ';
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            if (!previousNode && /^\s{4}/.test(node.textContent)) text = node.textContent.replace(fourSpaces, '\u200c' + fourSpaces);
            const lines = text.split('\n');
            for(let i = 0; i < lines.length; i++){
                const startOfLine = state.atBlank() || !!state.closed;
                state.write();
                state.out += (0, $8q1Q5.escapeMarkdown)(lines[i], startOfLine, state.context.insideTable);
                if (i !== lines.length - 1) {
                    if (lines[i] && lines[i].length && lines[i + 1] && lines[i + 1].length) state.out += '  ';
                    state.out += '\n';
                }
            }
            // This is so we can determine which marks are most used that aren't being converted to markdown
            node.marks.forEach((mark)=>{
                // @ts-expect-error
                if (!$e985dce6263f3bba$export$3a8025f2f3e0c64[mark.type.name]) state.updateNonErrorFallbackState(mark);
            });
        },
        support: 'full'
    },
    empty_line: {
        serialize ({ state: state, node: node }) {
            state.write('\u200c'); // zero-width-non-joiner
            state.closeBlock(node);
        },
        support: 'full'
    },
    placeholder: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'placeholder', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'placeholder',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="placeholder" data-id="${id}">${node.attrs.text}</custom>`);
            }
        },
        support: 'custom'
    },
    mention: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const isLastNode = parent.childCount === index + 1;
            let delimiter = '';
            if (!isLastNode) {
                const nextNode = parent.child(index + 1);
                const nextNodeHasLeadingSpace = nextNode.textContent.indexOf(' ') === 0;
                delimiter = nextNodeHasLeadingSpace ? '' : ' ';
            }
            // Get the name from the map
            const name = state.mentionMap[node.attrs.id] || '';
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mention', {
                    ...node.attrs,
                    text: `@${name}`
                }) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mention',
                    // Update the attributes to include resolved name
                    attributes: {
                        ...node.attrs,
                        text: `@${name}`
                    }
                };
                if (state.featureToggles.markdownPlusAttributeTest) {
                    // @ts-expect-error
                    node.attrs.text = `@${name}`;
                    state.write(`<custom data-type="mention" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">@${name}</custom>`);
                } else state.write(`<custom data-type="mention" data-id="${id}">@${name}</custom>`);
            } else state.write(`${name}${delimiter}`);
        },
        support: 'custom'
    },
    date: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'date', node.attrs) : `id-${state.idCounter++}`;
                // Ensure localId is explicitly set to null if not present
                const attributes = {
                    ...node.attrs,
                    localId: node.attrs.localId ?? null
                };
                state.idMap[id] = {
                    type: 'date',
                    attributes: attributes
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="date" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
                else state.write(`<custom data-type="date" data-id="${id}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
            } else state.write(new Intl.DateTimeFormat().format(Number(node.attrs.timestamp)));
        },
        support: 'custom'
    },
    emoji: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'emoji', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'emoji',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="emoji" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.shortName}</custom>`);
                else state.write(`<custom data-type="emoji" data-id="${id}">${node.attrs.shortName}</custom>`);
            } else state.write(node.attrs.shortName);
        },
        support: 'custom'
    },
    inlineCard: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineCard', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineCard',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="smartlink" data-id="${id}">${node.attrs.url}</custom>`);
            } else state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'custom'
    },
    status: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'status', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'status',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="status" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.text}</custom>`);
                else state.write(`<custom data-type="status" data-id="${id}">${node.attrs.text}</custom>`);
            } else // this will trigger the fallback conversion (text)
            throw new Error('Token type `status` not supported by Markdown renderer');
        },
        support: 'custom'
    },
    layoutSection: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutSection', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutSection',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutSection_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutSection_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    layoutColumn: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutColumn', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutColumn',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutColumn_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutColumn_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    expand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'expand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'expand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="expand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="expand_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    nestedExpand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'nestedExpand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'nestedExpand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="nestedExpand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="nestedExpand_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    panel: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusPanels) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'panel', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'panel',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="panel_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="panel_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'custom'
    },
    blockCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    embedCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    decisionList: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionList', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionList',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionList_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`<custom data-type="decisionList_close" />\n\n`);
            } else {
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`\n\n`);
            }
        },
        support: 'custom'
    },
    decisionItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionItem', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionItem',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionItem_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`\n\n<custom data-type="decisionItem_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    extension: {
        serialize ({ state: state, node: node }) {
            // For native embed extension nodes, output the embedded URL as a markdown link
            // so that it's visible to Rovo (same as embedCard/blockCard serialization)
            if (node.attrs.extensionKey?.startsWith('native-embed:')) {
                const url = node.attrs.parameters?.macroParams?.url?.value;
                if (url) {
                    state.write(`[${url}](${url})`);
                    return;
                }
            }
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'extension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'extension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="extension" data-id="${id}" />\n\n`);
            }
        },
        support: 'custom'
    },
    inlineExtension: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="inlineExtension" data-id="${id}"></custom>`);
            }
        },
        support: 'custom'
    },
    bodiedExtension: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'bodiedExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'bodiedExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="bodiedExtension_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="bodiedExtension_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    fallback: {
        serialize ({ state: state, node: node }) {
            // If PMNode is an unhandled block node, we need to add a newline
            // after the content to prevent the next line from being rendered as
            // part of the block node.
            if (node.isBlock) state.write(`${node.textContent || node.attrs.text || ''}\n\n`);
            else state.write(node.textContent || node.attrs.text || '');
        },
        support: 'fallback'
    }
};
const $e985dce6263f3bba$export$695720b7e7a61533 = {
    ...$e985dce6263f3bba$var$editorNodes,
    ...(0, $2xv4m.default)
};
const $e985dce6263f3bba$export$3a8025f2f3e0c64 = {
    em: {
        open: '_',
        close: '_',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: '**',
        close: '**',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strike: {
        open: '~~',
        close: '~~',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open: '[',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        close (_state, mark) {
            return '](' + mark.attrs['href'] + ')';
        }
    },
    code: {
        open: '`',
        close: '`'
    }
};
module.exports["MarkdownSerializerState"] = $e985dce6263f3bba$export$61055fa707e69319;

});

parcelRegister("2xv4m", function(module, exports) {

var $2VvL9 = parcelRequire("2VvL9");

const $deb7030063275628$var$isHeaderRow = (row)=>row.child(0).type.name === 'tableHeader';
const $deb7030063275628$var$isFirstRow = (row, parent)=>parent.content.child(0) === row;
const $deb7030063275628$var$isHeaderRowPresent = (table)=>{
    let headerRowPresent = false;
    table.content.forEach((row)=>{
        if ($deb7030063275628$var$isHeaderRow(row)) headerRowPresent = true;
    });
    return headerRowPresent;
};
const $deb7030063275628$var$renderNode = (state, node, index)=>{
    if (index > 0) state.write(' ');
    node.content.forEach((child, i)=>{
        if (child.isTextblock || child.type.name === 'mediaSingle') {
            if (i > 0) state.write(' ');
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = true;
            state.renderInline(child);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = false;
        } else $deb7030063275628$var$renderNode(state, child, i);
    });
};
const $deb7030063275628$var$renderInlineContent = ({ state: state, node: node })=>{
    state.write('| ');
    $deb7030063275628$var$renderNode(state, node, 0);
    state.write(' ');
};
const $deb7030063275628$var$tableNodes = {
    table: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="table_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>state.render(child, node, i));
                state.write(`<custom data-type="table_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles, {
                    layout: node.attrs.layout,
                    localId: node.attrs.localId,
                    width: 760
                })) state.updateNonErrorFallbackState(node);
                const headerRowPresent = $deb7030063275628$var$isHeaderRowPresent(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            headerRowPresent: headerRowPresent,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.closeBlock(node);
            }
        },
        support: 'partial'
    },
    tableRow: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="tr_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="tr_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            ...options,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write('|');
                state.ensureNewLine();
                if ($deb7030063275628$var$isHeaderRow(node) || $deb7030063275628$var$isFirstRow(node, parent)) {
                    for(let i = 0; i < node.childCount; i++)state.write('| --- ');
                    state.write('|');
                    state.ensureNewLine();
                }
            }
        },
        support: 'partial'
    },
    tableHeader: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="th_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="th_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $deb7030063275628$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    },
    tableCell: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="td_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="td_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $deb7030063275628$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    }
};
var $deb7030063275628$export$2e2bcd8739ae039 = $deb7030063275628$var$tableNodes;
module.exports["default"] = $deb7030063275628$export$2e2bcd8739ae039;

});

parcelRegister("2VvL9", function(module, exports) {
const $92afea9a8f6a2cee$export$5be26e657c035da4 = (node, featureToggles, overrideDefaults = {})=>{
    if (!featureToggles.allowAttributesMatchDefault) return true;
    // @ts-expect-error - node.type.attrs does not exist in nodeType type, but it does exist.
    const nodeTypeAttrs = node.type.attrs;
    if (!nodeTypeAttrs || Object.keys(nodeTypeAttrs).length === 0 && Object.keys(node.attrs).length === 0) return true;
    const defaultAttrs = {};
    Object.keys(nodeTypeAttrs).forEach((key)=>{
        defaultAttrs[key] = nodeTypeAttrs[key].default;
    });
    // The actual node defaults don't match the node defaults when interacting with a page
    // So we override for a correct comparison
    Object.keys(overrideDefaults).forEach((key)=>{
        defaultAttrs[key] = overrideDefaults[key];
    });
    // Compare the node attributes to the default attributes
    for(const key in node.attrs){
        if (node.attrs[key] !== defaultAttrs[key]) return false;
    }
    return true;
};
module.exports["attributesMatchDefault"] = $92afea9a8f6a2cee$export$5be26e657c035da4;

});

parcelRegister("bd943", function(module, exports) {
const $3b4ff3e4ad90548c$export$53fd140c96bc558 = 'https://media.staging.atl-paas.net';
module.exports["MEDIA_BASE_URL_STAGING"] = $3b4ff3e4ad90548c$export$53fd140c96bc558;

});

parcelRegister("50zV1", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

const $6ff1f24202635c31$export$8ef94ae42a3729bd = 1;
const $6ff1f24202635c31$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $6ff1f24202635c31$export$4ea3c6bbdf8f7944 = (maybeOrderedListNode)=>{
    if (!(maybeOrderedListNode instanceof (0, $5SAOw.Node))) return $6ff1f24202635c31$export$8ef94ae42a3729bd;
    const order = maybeOrderedListNode?.attrs?.order;
    return $6ff1f24202635c31$export$d445360e2a3c026b(order) ?? $6ff1f24202635c31$export$8ef94ae42a3729bd;
};
module.exports["getOrderFromMaybeOrderedListNode"] = $6ff1f24202635c31$export$4ea3c6bbdf8f7944;

});

parcelRegister("8q1Q5", function(module, exports) {
/**
 * A replacement for `String.repeat` until it becomes widely available.
 */ function $74c7a8487430b8e3$export$345d822805ab3239(text, length) {
    let result = '';
    for(let x = 0; x < length; x++)result += text;
    return result;
}
function $74c7a8487430b8e3$export$560888d6fe0cfe97(str, startOfLine, insideTable) {
    let strToEscape = str || '';
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    strToEscape = strToEscape.replace(/[`*\\~\[\]_]/g, (m, i)=>// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        m === '_' && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : '\\' + m);
    if (startOfLine) strToEscape = strToEscape// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\+[ ]|[\-*>])/, '\\$&')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\s*\d+)\.\s/, '$1\\. ');
    if (insideTable) // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    strToEscape = strToEscape.replace(/[|]/g, '\\$&');
    return strToEscape;
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $74c7a8487430b8e3$var$SPECIAL_CHARACTERS = /\u200c|↵/g;
function $74c7a8487430b8e3$var$removeSpecialCharacters(node) {
    if (node.nodeType === 3 && node.textContent) node.textContent = node.textContent.replace($74c7a8487430b8e3$var$SPECIAL_CHARACTERS, '');
    Array.from(node.childNodes).forEach((child)=>$74c7a8487430b8e3$var$removeSpecialCharacters(child));
}
function $74c7a8487430b8e3$export$9c95763b5a419f4c(html, options) {
    const el = document.createElement('div');
    el.innerHTML = html;
    // Remove zero-width-non-joiner
    Array.from(el.querySelectorAll('p')).forEach((p)=>{
        $74c7a8487430b8e3$var$removeSpecialCharacters(p);
    });
    // Convert mention containers, i.e.:
    //   <a href="/abodera/" rel="nofollow" title="@abodera" class="mention mention-me">Artur Bodera</a>
    Array.from(el.querySelectorAll('a.mention, a.ap-mention')).forEach((a)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = a.getAttribute('data-atlassian-id') || '';
        if (atlassianId) // Atlassian ID is wrapped in curlies so that it get serialized as @{aid-id} instead of @aid-id
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        else {
            const title = a.getAttribute('title') || '';
            if (title) {
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const usernameMatch = title.match(/^@(.*?)$/);
                if (usernameMatch) {
                    const username = usernameMatch[1];
                    span.setAttribute('data-mention-id', username);
                }
            }
        }
        const text = a.textContent || '';
        if (text.indexOf('@') === 0) span.textContent = a.textContent;
        else span.textContent = `@${a.textContent}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.insertBefore(span, a);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Convert mention containers, i.e.:
    //   <span class="ap-mention" data-atlassian-id="5c09bf77ec71bd223bbe866f">@Scott Demo</span>
    Array.from(el.querySelectorAll('span.ap-mention')).forEach((s)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = s.getAttribute('data-atlassian-id') || '';
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        const text = s.textContent || '';
        span.textContent = text.indexOf('@') === 0 ? text : `@${text}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.insertBefore(span, s);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.removeChild(s);
    });
    // Parse emojis i.e.
    //     <img src="https://d301sr5gafysq2.cloudfront.net/207268dc597d/emoji/img/diamond_shape_with_a_dot_inside.svg" alt="diamond shape with a dot inside" title="diamond shape with a dot inside" class="emoji">
    Array.from(el.querySelectorAll('img.emoji')).forEach((img)=>{
        const span = document.createElement('span');
        let shortName = img.getAttribute('data-emoji-short-name') || '';
        if (!shortName) {
            // Fallback to parsing Bitbucket's src attributes to find the
            // short name
            const src = img.getAttribute('src');
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            const idMatch = !src ? false : src.match(/([^\/]+)\.[^\/]+$/);
            if (idMatch) shortName = `:${decodeURIComponent(idMatch[1])}:`;
        }
        if (shortName) span.setAttribute('data-emoji-short-name', shortName);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(span, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    if (!options.disableBitbucketLinkStripping) // Convert all automatic links to plain text, because they will be re-created on render by the server
    Array.from(el.querySelectorAll('a'))// Don't convert external links (i.e. not automatic links)
    .filter((a)=>a.getAttribute('data-is-external-link') !== 'true' && a.getAttribute('data-inline-card') === null).forEach((a)=>{
        Array.from(a.childNodes).forEach((child)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            a.parentNode.insertBefore(child, a);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Parse images
    // Not using :pseudo because of IE11 bug:
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16104908/
    Array.from(el.querySelectorAll('img')).filter((img)=>!img.classList.contains('emoji')).forEach((img)=>{
        const { parentNode: parentNode } = img;
        if (!parentNode) return;
        /**
     * Lift image node if parent isn't the root-element
     */ if (parentNode !== el) {
            const isValidPath = validateImageNodeParent(parentNode);
            if (!isValidPath) liftImageNode(parentNode, img);
        }
        /**
     * Replace image with media node
     */ const mediaSingle = document.createElement('div');
        mediaSingle.setAttribute('data-node-type', 'mediaSingle');
        const media = document.createElement('div');
        media.setAttribute('data-node-type', 'media');
        media.setAttribute('data-type', 'external');
        media.setAttribute('data-alt', img.getAttribute('alt') || '');
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        media.setAttribute('data-url', img.getAttribute('src'));
        mediaSingle.appendChild(media);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(mediaSingle, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    function validateImageNodeParent(node) {
        const ALLOWED_PARENTS = [
            'LI',
            'UL',
            'OL',
            'TD',
            'TH',
            'TR',
            'TBODY',
            'THEAD',
            'TABLE'
        ];
        if (node === el) return true;
        if (ALLOWED_PARENTS.indexOf(node.nodeName) === -1) return false;
        if (!node.parentNode) return false;
        return validateImageNodeParent(node.parentNode);
    }
    function liftImageNode(node, img) {
        let foundParent = false;
        let parent = node;
        while(!foundParent){
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            foundParent = validateImageNodeParent(parent.parentNode);
            if (!foundParent) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent = parent.parentNode;
        }
        const cloned = parent.cloneNode();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const target = parent !== el ? parent.parentNode : el;
        while(img.nextSibling)cloned.appendChild(img.nextSibling);
        if (node !== parent) while(node.nextSibling)cloned.appendChild(node.nextSibling);
        if (parent.nextSibling) {
            target.insertBefore(cloned, parent.nextSibling);
            target.insertBefore(img, cloned);
        } else {
            target.appendChild(img);
            target.appendChild(cloned);
        }
        /**
     * If the splitting operation results in
     * the old parent being empty, remove it
     */ if (node.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        node.parentNode.removeChild(node);
        /**
     * Remove cloned element if it's empty.
     */ if (cloned.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cloned.parentNode.removeChild(cloned);
    }
    return el;
}
module.exports["stringRepeat"] = $74c7a8487430b8e3$export$345d822805ab3239;
module.exports["escapeMarkdown"] = $74c7a8487430b8e3$export$560888d6fe0cfe97;

});

parcelRegister("b4emg", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hbEec = parcelRequire("hbEec");

const $8841f32d2d46ed1f$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });
module.exports["getEmptyADF"] = $8841f32d2d46ed1f$export$d109ab46c9575565;

});

parcelRegister("hAuc5", function(module, exports) {

var $2Yzoe = parcelRequire("2Yzoe");


var $csam1 = parcelRequire("csam1");


var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");


var $1D8rU = parcelRequire("1D8rU");


var $aLtij = parcelRequire("aLtij");


var $1MDnJ = parcelRequire("1MDnJ");


var $dpgtc = parcelRequire("dpgtc");


var $2mgEK = parcelRequire("2mgEK");


var $fMMkB = parcelRequire("fMMkB");


var $6dzgm = parcelRequire("6dzgm");


var $locel = parcelRequire("locel");


var $ip5oL = parcelRequire("ip5oL");


var $ifgRb = parcelRequire("ifgRb");


var $2XcI5 = parcelRequire("2XcI5");


var $9tykg = parcelRequire("9tykg");


var $d5C9r = parcelRequire("d5C9r");


var $2OwON = parcelRequire("2OwON");

function $ce78ef6bb9d33c7d$var$getFragmentBackingArray(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $ce78ef6bb9d33c7d$var$mapFragment(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($ce78ef6bb9d33c7d$var$mapFragment(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $5SAOw.Fragment)) children.push(...$ce78ef6bb9d33c7d$var$getFragmentBackingArray(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $5SAOw.Fragment).fromArray(children);
}
function $ce78ef6bb9d33c7d$export$b2bf04f78f72b123({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const { markdownPlus: markdownPlus } = featureToggles;
    const tokenizer = new (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))('zero', {
        html: false
    });
    tokenizer.enable([
        // Process html entity - &#123;, &#xAF;, &quot;, ...
        'entity',
        // Process escaped chars and hardbreaks
        'escape',
        'newline'
    ]);
    [
        'nodes',
        'marks'
    ].forEach((key)=>{
        for(const idx in (0, $1D8rU.PM_SCHEMA_TO_MD_MAPPING)[key])if (schema[key][idx]) tokenizer.enable((0, $1D8rU.PM_SCHEMA_TO_MD_MAPPING)[key][idx]);
    });
    const analyticsAttributes = {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {}
    };
    // Remove once markdownPlusAttributeTest is removed
    const markdownPlusAttributeStatus = [];
    if (markdownPlus) {
        tokenizer.use((0, $dpgtc.default), idMap, featureToggles, analyticsAttributes);
        tokenizer.use((0, $fMMkB.default), idMap);
        tokenizer.use((0, $2mgEK.default), idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus);
    }
    tokenizer.use((0, $1MDnJ.default), idMap);
    tokenizer.use((0, $9tykg.default));
    // enable modified version of linkify plugin
    // @see https://product-fabric.atlassian.net/browse/ED-3097
    tokenizer.use((0, $locel.default));
    tokenizer.use((0, $ifgRb.default));
    tokenizer.use((0, $6dzgm.default));
    // Custom Table tokenizer
    if (schema.nodes.table) tokenizer.use((0, $csam1.markdownItTable));
    // Custom Media tokenizer
    if (schema.nodes.media && schema.nodes.mediaSingle) {
        if (featureToggles.markdownPlusUseNextMediaPlugin) tokenizer.use((0, $2XcI5.default));
        else tokenizer.use((0, $ip5oL.markdownItMedia));
        if (markdownPlus && featureToggles.markdownPlusAddComplexNodes) tokenizer.use((0, $aLtij.default));
    }
    // Custom TaskList tokenizer
    if (schema.nodes.taskList) tokenizer.use((0, $d5C9r.default));
    const markdownParser = new (0, $42JDa.MarkdownParser)(schema, tokenizer, (0, $1D8rU.filterMdToPmSchemaMapping)(schema, (0, $1D8rU.getMdToPmMapping)(!!markdownPlus)));
    if (markdown === '') return {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {},
        markdownPlusAttributeStatus: [],
        pmFragment: (0, $5SAOw.Fragment).empty
    };
    // normalize duplicated backticks (needed as a safeguard to avoid rendering malformed escape characters coming from backed)
    // the case with newline characters
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/\\n/g, '\n');
    // the case with custom field attributes (limit only to data- attributes inside custom fields)
    if (markdownPlus) // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/<custom[^>]*?>/g, function(match) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return match.replace(/(data-\w+=)\\\"(.*?)\\\"/g, '$1"$2"');
    });
    const prosemirrorNode = markdownPlus ? markdownParser.parse(markdown) : markdownParser.parse((0, $2OwON.escapeLinks)(markdown));
    if (!prosemirrorNode.content) throw new Error('Markdown conversion did not result in a valid document being created');
    // This logic is duplicated from editor-cores paste transformation.
    // The editor-plugin-ai package is avoiding sharing dependencies with editor-core to support
    // products using it with various versions of editor packages.
    // The duplication is from the following file:
    // packages/editor/editor-core/src/plugins/media/utils/media-single.ts
    // WARNING
    // If the `mapFragment` usage changes -- it means we have a breaking change for products
    // where currently it's expected they are using older versions of editor-common
    const mappedContent = $ce78ef6bb9d33c7d$var$mapFragment(prosemirrorNode.content, (node)=>{
        if (node.type.name === 'media') {
            const replacedAttrs = Object.fromEntries(Object.entries(node.attrs).map(([key, value])=>{
                // If value is the literal string 'null', convert it to JS null
                return [
                    key,
                    value === 'null' ? null : value
                ];
            }));
            return schema.nodes.media.createChecked({
                ...replacedAttrs,
                // Adding this attribute results in the media node being rendered
                // initially using the external url, but then triggering an upload
                // of the external url as an atlassian artifact, and this media
                // will then be replaced to use the atlassian artifact.
                //
                // This is done in the media nodeview by checking the attributes
                // when rendering.
                __external: replacedAttrs.type === 'external',
                __mediaTraceId: null
            }, node.content, node.marks);
        }
        return node;
    });
    return {
        ...analyticsAttributes,
        markdownPlusAttributeStatus: markdownPlusAttributeStatus,
        pmFragment: mappedContent
    };
}
function $ce78ef6bb9d33c7d$export$e661a057c2263d64({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const fragment = $ce78ef6bb9d33c7d$export$b2bf04f78f72b123({
        markdown: markdown,
        schema: schema,
        idMap: idMap,
        featureToggles: {
            markdownPlus: true,
            ...featureToggles
        }
    });
    try {
        const node = schema.nodes.doc.createChecked({}, fragment.pmFragment);
        return node;
    } catch  {
        throw new Error('Markdown conversion did not result in a valid ProseMirror node');
    }
}
module.exports["convertMarkdownToProsemirror"] = $ce78ef6bb9d33c7d$export$b2bf04f78f72b123;
module.exports["backendConvertMarkdownToProsemirrorNode"] = $ce78ef6bb9d33c7d$export$e661a057c2263d64;

});

parcelRegister("1D8rU", function(module, exports) {
function $fe15ff31308e86c4$export$a9d25ff08f358d72(schema, map) {
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $fe15ff31308e86c4$export$b535e2638dcce02 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $fe15ff31308e86c4$export$8f853a1c35ed8bbe = (extendMarkdownSupport)=>({
        blockquote: {
            block: 'blockquote'
        },
        paragraph: {
            block: 'paragraph'
        },
        em: {
            mark: 'em'
        },
        strong: {
            mark: 'strong'
        },
        link: {
            mark: 'link',
            attrs: (tok)=>{
                // @ts-expect-error
                if (tok.pmAttrs) // @ts-expect-error
                return tok.pmAttrs;
                else return {
                    href: tok.attrGet('href'),
                    title: tok.attrGet('title') || null
                };
            }
        },
        hr: {
            node: 'rule'
        },
        heading: {
            block: 'heading',
            attrs: (tok)=>({
                    level: +tok.tag.slice(1)
                })
        },
        softbreak: {
            node: 'hardBreak'
        },
        hardbreak: {
            node: 'hardBreak'
        },
        code_block: {
            block: 'codeBlock'
        },
        list_item: {
            block: 'listItem'
        },
        bullet_list: {
            block: 'bulletList'
        },
        ordered_list: {
            block: 'orderedList',
            attrs: (tok)=>({
                    order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
                })
        },
        code_inline: {
            mark: 'code'
        },
        code: {
            mark: 'code'
        },
        fence: {
            block: 'codeBlock',
            // we trim any whitespaces around language definition
            attrs: (tok)=>({
                    language: tok.info && tok.info.trim() || null
                })
        },
        mediaInline: {
            node: 'mediaInline',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media_single: {
            block: 'mediaSingle',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media: {
            node: 'media',
            attrs: (token)=>{
                // When token.pmAttrs is missing it means it's an external image.
                // @ts-expect-error
                if (token.pmAttrs) // @ts-expect-error
                return token.pmAttrs;
                return {
                    url: token.attrGet('url'),
                    type: 'external'
                };
            }
        },
        caption: {
            block: 'caption',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        alignment: {
            mark: 'alignment',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        breakout: {
            mark: 'breakout',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        border: {
            mark: 'border',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        textColor: {
            mark: 'textColor',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        underline: {
            mark: 'underline',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        subsup: {
            mark: 'subsup',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        emoji: {
            node: 'emoji',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {
                    shortName: `:${token.markup}:`,
                    text: token.content
                };
            }
        },
        inlineCard: {
            node: 'inlineCard',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        date: {
            node: 'date',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        status: {
            node: 'status',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        mention: {
            node: 'mention',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        placeholder: {
            node: 'placeholder',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        table: {
            block: 'table',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        tr: {
            block: 'tableRow',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        th: {
            block: 'tableHeader',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        td: {
            block: 'tableCell',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        s: {
            mark: 'strike'
        },
        strike: {
            mark: 'strike'
        },
        task_list: {
            block: 'taskList'
        },
        task_item: {
            block: 'taskItem',
            attrs: (tok)=>({
                    state: tok.meta
                })
        },
        layoutSection: {
            block: 'layoutSection',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        layoutColumn: {
            block: 'layoutColumn',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        panel: {
            block: 'panel',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionList: {
            block: 'decisionList',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionItem: {
            block: 'decisionItem',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        expand: {
            block: 'expand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        extension: {
            node: 'extension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        bodiedExtension: {
            block: 'bodiedExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        nestedExpand: {
            block: 'nestedExpand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        inlineExtension: {
            node: 'inlineExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        }
    });
module.exports["filterMdToPmSchemaMapping"] = $fe15ff31308e86c4$export$a9d25ff08f358d72;
module.exports["PM_SCHEMA_TO_MD_MAPPING"] = $fe15ff31308e86c4$export$b535e2638dcce02;
module.exports["getMdToPmMapping"] = $fe15ff31308e86c4$export$8f853a1c35ed8bbe;

});

parcelRegister("aLtij", function(module, exports) {
$parcel$export(module.exports, "default", () => $0773845a48a88423$export$2e2bcd8739ae039);
const $0773845a48a88423$var$captionOpen = 'caption_open';
const $0773845a48a88423$var$paragraphOpen = 'paragraph_open';
const $0773845a48a88423$var$paragraphClose = 'paragraph_close';
function $0773845a48a88423$export$eee367902819022(index, tokens) {
    // make sure we have an opening and closing paragraph token
    if (tokens[index]?.type !== $0773845a48a88423$var$paragraphOpen && tokens[index + 2]?.type !== $0773845a48a88423$var$paragraphClose) return;
    // remove the closing paragraph token from state.tokens so we don't add it into the acc
    // when we loop through the tokens
    tokens[index + 2]?.type === $0773845a48a88423$var$paragraphClose && tokens.splice(index + 2, 1);
    // return empty to prevent adding the opening token to the acc
    return;
}
function $0773845a48a88423$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'caption', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            const isWithinCaption = acc[acc.length - 1]?.type === $0773845a48a88423$var$captionOpen;
            if (type === $0773845a48a88423$var$paragraphOpen && isWithinCaption) /**
				 * paragraph_open and paragraph_close tokens get automatically added by markdown-it
				 * around text content. caption nodes do not allow paragraph nodes as children
				 * so we need to prevent these tokens from being added to the acc
				 */ $0773845a48a88423$export$eee367902819022(index, state.tokens);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("1MDnJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e92fa7dc1daa52ee$export$2e2bcd8739ae039);
function $e92fa7dc1daa52ee$export$2e2bcd8739ae039(md) {
    md.inline.ruler.before('text', 'citation', function(state, silent) {
        const str = state.src.slice(state.pos);
        /**
		 * Matches the following:
		 * [^00^]
		 */ // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const citationRegexp = /^\[\^[^\^]+\^]/;
        const match = citationRegexp.exec(str);
        if (!match) return false;
        if (silent) return true;
        // Just skip citation from parsing and don't render them in the output.
        state.pos += match[0].length;
        return true;
    });
}

});

parcelRegister("dpgtc", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cab79ce214481e1$export$2e2bcd8739ae039);

var $7MY8y = parcelRequire("7MY8y");


var $hqwd7 = parcelRequire("hqwd7");

// Some nodes will be inline but it's content will be empty.
// That's why, don't remove paragraphs wrapping it.
// For example, inlineExtension is inline node, so there should be no content inside it.
//  So it's custom element is represented by <custom data-type="inlineExtension" ... />
const $4cab79ce214481e1$var$emptyInlineCustomNodes = [
    'inlineExtension'
];
function $4cab79ce214481e1$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes) {
    md.core.ruler.after('inline', 'custom-block', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const match = token.content.match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123" />
				 * <custom data-type="smartlink" />
				 * <custom data-type="panel_open" data-id="123" />
				 * <custom data-type="panel_close" />
				 */ // Ignored via go/ees005
            // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
            // eslint-disable-next-line require-unicode-regexp
            RegExp('<custom\\s+data-type="(?<dataType>.*?)"\\s*(data-id="(?<dataId>.*?)"\\s*)?\\/>'));
            const dataType = match?.groups?.dataType;
            if (match && dataType && !$4cab79ce214481e1$var$emptyInlineCustomNodes.includes(dataType)) {
                const dataId = match.groups?.dataId;
                if (dataType) {
                    analyticsAttributes.htmlConvertedToNodes++;
                    const customElementToken = (0, $7MY8y.createToken)(state, dataType);
                    if (dataId && idMap[dataId]) // @ts-ignore
                    customElementToken.pmAttrs = idMap[dataId].attributes;
                    customElementToken.attrPush([
                        'isCustomBlock',
                        'true'
                    ]);
                    /**
					 * When the custom tag goes through the tokenizer it is transformed into this structure:
					 * paragraph_open
					 * inline
					 * paragraph_close
					 *
					 * so the following section removes the wrapping paragraph tokens
					 */ acc.splice(acc.length - 1, 1);
                    state.tokens.splice(index + 1, 1);
                    // We then push replace the inline token with our custom token
                    acc.push(customElementToken);
                } else {
                    analyticsAttributes.htmlConvertedToFallbackNodes++;
                    acc.push(token);
                }
            } else acc.push(token);
            return acc;
        }, []);
        const toRemove = (0, $hqwd7.sanitizeCustomBlocks)(state.tokens);
        toRemove.forEach((index)=>{
            const tokenToBeRemoved = state.tokens[index];
            analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] = (analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] || 0) + 1;
        });
        // Remove all indices that have been set in `toRemove`
        if (featureToggles.markdownPlusRemoveUnclosedTokens) state.tokens = state.tokens.filter((_, index)=>!toRemove.has(index));
    });
}

});

parcelRegister("7MY8y", function(module, exports) {
function $6d1436b1813e587d$export$c255480b061bd6aa(state, type, level) {
    let nesting;
    if (type.includes('_open')) nesting = 1;
    else if (type.includes('_close')) nesting = -1;
    else nesting = 0;
    const token = new state.Token(type, '', nesting);
    if (level) token.level = level;
    return token;
}
module.exports["createToken"] = $6d1436b1813e587d$export$c255480b061bd6aa;

});

parcelRegister("hqwd7", function(module, exports) {
function $bb6e978431b17277$export$e717b161ec14d433(tokens) {
    const openTokenIndexMap = new Map();
    const toRemove = new Set();
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // This attribute is set earlier in this file (customElementToken.attrPush(['isCustomBlock', 'true']))
        // So we can identify tokens added by this rule
        if (token.attrGet('isCustomBlock') === 'true') {
            // We split by the last underscore
            const type = token.type.substring(0, token.type.lastIndexOf('_'));
            const prevIndex = openTokenIndexMap.get(type);
            // Only check for removal if type exists
            if (type && token.nesting === 1) {
                if (prevIndex !== undefined) toRemove.add(prevIndex);
                openTokenIndexMap.set(type, i);
            } else if (type && token.nesting === -1) {
                if (prevIndex !== undefined) // If previous open token found, then we've found a match and we can close it
                openTokenIndexMap.delete(type);
                else toRemove.add(i);
            }
        }
    }
    // Anything left in the stack is an unmatched open token
    openTokenIndexMap.forEach((remainingIndex)=>toRemove.add(remainingIndex));
    return toRemove;
}
module.exports["sanitizeCustomBlocks"] = $bb6e978431b17277$export$e717b161ec14d433;

});

parcelRegister("2mgEK", function(module, exports) {
$parcel$export(module.exports, "default", () => $102908d0f0788df0$export$2e2bcd8739ae039);

var $a4TK8 = parcelRequire("a4TK8");

function $102908d0f0788df0$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus) {
    const rule = md.inline.ruler.before('text', 'custom', function(state, silent) {
        const start = state.pos;
        const origSrc = state.src;
        let match;
        if (featureToggles.markdownPlusAttributeTest) match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 * <custom data-type="status" data-id="id-0" data-attrs='{"text":"test","color":"neutral"}'>test</custom>
				 */ // Ignored via go/ees005
        // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
        // eslint-disable-next-line require-unicode-regexp
        RegExp('<custom(?:\\s+data-type="(?<dataType>[^"]*)")?(?:\\s+data-id="(?<dataId>[^"]*)")?(?:\\s+data-attrs="(?<dataAttrs>\\{.*?\\})")?\\s*>(?<dataContent>.*?)<\\/custom>'));
        else match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 */ // Ignored via go/ees005
        // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
        // eslint-disable-next-line require-unicode-regexp
        RegExp('<custom(\\sdata-(type|id)="(?<dataType>.*?)")?(\\sdata-(type|id)="(?<dataId>.*?)")?>(?<dataContent>.*?)<\\/custom>'));
        if (!match) return false;
        const tagLength = match[0].length;
        const beforeTag = state.src.slice(start, state.src.indexOf(match[0]));
        const dataType = match.groups?.dataType;
        const dataId = match.groups?.dataId;
        const dataAttrs = match.groups?.dataAttrs;
        const dataContent = match.groups?.dataContent;
        const afterTag = state.src.slice(start + beforeTag.length + tagLength);
        function mapCustomDataTypeToNodeType(customDataType) {
            switch(customDataType){
                case 'smartlink':
                    return 'inlineCard';
                case 'date':
                case 'emoji':
                case 'status':
                case 'mention':
                case 'placeholder':
                    return customDataType;
                // Just move below case alongside mention above to remove markdownPlusExtensions FF.
                case 'inlineExtension':
                    return featureToggles.markdownPlusExtensions ? 'inlineExtension' : false;
                case 'mediaInline':
                    return featureToggles.markdownPlusAddComplexNodes ? 'mediaInline' : false;
                default:
                    return false;
            }
        }
        const customDataType = mapCustomDataTypeToNodeType(dataType);
        if (!silent) {
            // tokenize beforeTag
            if (beforeTag) {
                state.src = beforeTag;
                // @ts-ignore
                state.md.inline.tokenize(state, beforeTag);
            }
            if (featureToggles.markdownPlusAttributeTest && featureToggles.markdownPlusMentions && !dataId && dataAttrs && customDataType) {
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = dataAttrs;
            }
            if (dataId && idMap?.[dataId]?.attributes && customDataType) {
                analyticsAttributes.htmlConvertedToNodes++;
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = idMap[dataId].attributes;
                if (featureToggles.markdownPlusAttributeTest && dataAttrs) try {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(idMap[dataId].attributes, JSON.parse(dataAttrs))) markdownPlusAttributeStatus.push([
                        customDataType,
                        true
                    ]);
                    else // We need to check this because when you type it calls this function multiple times and the first time its called the current text is not the same
                    if (idMap[dataId].attributes.text === JSON.parse(dataAttrs).text) markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                } catch (e) {
                    markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                }
            } else {
                analyticsAttributes.htmlConvertedToFallbackNodes++;
                const textToken = state.push('text', '', 0);
                // If there is no data content we want to hide the custom tags as the AI has hallucinated something
                if (!dataContent) textToken.content = '';
                else textToken.content = dataContent || match[0];
            }
            if (afterTag) {
                state.src = afterTag;
                state.pos = 0;
                // @ts-ignore
                state.md.inline.tokenize(state, afterTag);
            }
        }
        state.src = origSrc;
        state.pos = start + state.src.length;
        return true;
    });
    return rule;
}

});

parcelRegister("fMMkB", function(module, exports) {
$parcel$export(module.exports, "default", () => $b85e013b8e2ab0fc$export$2e2bcd8739ae039);
const $b85e013b8e2ab0fc$var$decisionItemOpen = 'decisionItem_open';
const $b85e013b8e2ab0fc$var$paragraphOpen = 'paragraph_open';
const $b85e013b8e2ab0fc$var$paragraphClose = 'paragraph_close';
const $b85e013b8e2ab0fc$var$inline = 'inline';
function $b85e013b8e2ab0fc$var$handleParagraphs(acc, token) {
    /**
	 * Traverse up the acc token array, and if a chain of one or more inline tokens are under
	 * a decisionItem_open token, then it is considered to be a paragraph_close token within
	 * a decision item.
	 *
	 * This also works for a paragraph_open token as inlineCount would be zero meaning that
	 * the conditional applies to when decisionItem_open is right above paragraph_open.
	 */ let inlineCount = 0;
    let inlineChainEnded = false;
    for(let i = acc.length - 1; i >= 0; i--){
        const type = acc[i]?.type;
        if (!inlineChainEnded) {
            if (type === $b85e013b8e2ab0fc$var$inline) inlineCount += 1;
            else inlineChainEnded = true;
        }
    }
    const isWithinDecisionItem = acc[acc.length - (inlineCount + 1)]?.type === $b85e013b8e2ab0fc$var$decisionItemOpen;
    if (!isWithinDecisionItem) acc.push(token);
}
function $b85e013b8e2ab0fc$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'decision-list', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $b85e013b8e2ab0fc$var$paragraphOpen || type === $b85e013b8e2ab0fc$var$paragraphClose) $b85e013b8e2ab0fc$var$handleParagraphs(acc, token);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("6dzgm", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6de2bb5deb5f668$export$2e2bcd8739ae039);
const $e6de2bb5deb5f668$var$replaceBrWithLineBreak = (text)=>{
    // Matches <br> or <br /> or <br/> with optional trailing space
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/<br\s*\/?>\s?/gi, '\n');
};
const $e6de2bb5deb5f668$var$processInlineChildren = (children)=>{
    for (const child of children)if (child.type === 'text') {
        const newText = $e6de2bb5deb5f668$var$replaceBrWithLineBreak(child.content);
        if (child.content !== newText) child.content = newText;
    }
};
const $e6de2bb5deb5f668$var$brToLineBreak = (state)=>{
    for (const token of state.tokens)if (token.type === 'inline' && token.children) $e6de2bb5deb5f668$var$processInlineChildren(token.children);
};
var $e6de2bb5deb5f668$export$2e2bcd8739ae039 = (md)=>md.core.ruler.after('inline', 'lineBreak', $e6de2bb5deb5f668$var$brToLineBreak);

});

parcelRegister("locel", function(module, exports) {
$parcel$export(module.exports, "default", () => $866d7fb158c265f1$export$2e2bcd8739ae039);
// File copied from packages/editor/editor-core/src/plugins/paste/linkify-md-plugin.ts

var $2Gb84 = parcelRequire("2Gb84");


var $81OAa = parcelRequire("81OAa");


var $2OwON = parcelRequire("2OwON");

// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $866d7fb158c265f1$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $866d7fb158c265f1$var$isLinkOpen = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<a[>\s]/i.test(str);
};
const $866d7fb158c265f1$var$isLinkClose = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<\/a\s*>/i.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $866d7fb158c265f1$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($866d7fb158c265f1$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($866d7fb158c265f1$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $81OAa.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $2OwON.findFilepaths)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $2OwON.isLinkInMatches)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $866d7fb158c265f1$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$866d7fb158c265f1$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $866d7fb158c265f1$var$linkify);

});

parcelRegister("2OwON", function(module, exports) {
// File copied from packages/editor/editor-core/src/plugins/hyperlink/utils.ts
// Regular expression for a windows filepath in the format <DRIVE LETTER>:\<folder name>\
// Ignored via go/ees005
const $7715b3c791c155be$export$893fccbed37586dd = // eslint-disable-next-line require-unicode-regexp
/([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $7715b3c791c155be$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($7715b3c791c155be$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $7715b3c791c155be$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $7715b3c791c155be$export$8acd10161c5f8b07(text) {
    return text.replace(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /(\[([^\]]+)\]\(|\!\[([^\]]*)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s]+)/g, (str)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s]+$/) ? `<${str}>` : str;
    });
}
module.exports["findFilepaths"] = $7715b3c791c155be$export$d37783fe63e2f0fe;
module.exports["isLinkInMatches"] = $7715b3c791c155be$export$5e652e74655163e5;
module.exports["escapeLinks"] = $7715b3c791c155be$export$8acd10161c5f8b07;

});

parcelRegister("ip5oL", function(module, exports) {
// File copied from packages/editor/editor-markdown-transformer/src/media.ts

var $bd943 = parcelRequire("bd943");

function $623b0b26b9c81375$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[[^\]]*\]\([^)]+\)/g;
    // Allow paragraph_close as a valid parent token for cases where a user has an image at the end of a paragraph
    // due to shift+enter
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'paragraph_close'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            if (url.includes((0, $bd943.MEDIA_BASE_URL_STAGING))) try {
                const urlObject = new URL(getUrl(url));
                const params = urlObject.searchParams;
                if (params.toString()) {
                    const pmAttrs = {};
                    for (const [key, value] of params)pmAttrs[key] = value;
                    // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
                    media.pmAttrs = pmAttrs;
                }
            } catch  {}
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && regx.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens// eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                .map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const matches = token.content.match(regx);
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + match.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $623b0b26b9c81375$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $623b0b26b9c81375$var$createRule());
};
module.exports["markdownItMedia"] = $623b0b26b9c81375$export$c8dcbd316b71f8cf;

});

parcelRegister("ifgRb", function(module, exports) {
$parcel$export(module.exports, "default", () => $73825321bd2619ae$export$2e2bcd8739ae039);
// file copied from packages/editor/editor-core/src/plugins/paste/newline-md-plugin.ts
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73825321bd2619ae$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$73825321bd2619ae$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $73825321bd2619ae$var$newline);

});

parcelRegister("2XcI5", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f17de48a6931d92$export$2e2bcd8739ae039);

var $bd943 = parcelRequire("bd943");


var $7MY8y = parcelRequire("7MY8y");

// eslint-disable-next-line require-unicode-regexp
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $3f17de48a6931d92$var$mediaRegex = /(!\[[^\]]*\]\([^)]+\))|(\[!\[[^\]]*\]\([^)]+\)\]\([^)]+\))/gu;
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $3f17de48a6931d92$var$INLINE_MEDIA_MATCH_REGEX = /!\[[^\]]*\]\([^)]+\)/u;
const $3f17de48a6931d92$var$getUrl = (state, str)=>{
    const res = state.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
    if (res.ok) {
        const href = state.md.normalizeLink(res.str);
        if (state.md.validateLink(href)) return href;
    }
    return '';
};
const $3f17de48a6931d92$var$checkPreviousToken = (type, acc)=>{
    return acc.length > 0 && acc[acc.length - 1].type === type;
};
const $3f17de48a6931d92$var$createMediaTokens = (url, state, acc)=>{
    const mediaSingleOpen = (0, $7MY8y.createToken)(state, 'media_single_open');
    const media = (0, $7MY8y.createToken)(state, 'media');
    media.attrs = [
        [
            'url',
            $3f17de48a6931d92$var$getUrl(state, url)
        ],
        [
            'type',
            'external'
        ]
    ];
    // This is a hack to get internal media to work
    // to recreate the image correctly we need to apply the pmAttrs from the image
    // We store the pmAttrs in the "fake" image url and apply them to the token
    if (url.includes((0, $bd943.MEDIA_BASE_URL_STAGING))) try {
        const urlObject = new URL($3f17de48a6931d92$var$getUrl(state, url));
        const params = urlObject.searchParams;
        if (params.toString()) {
            const pmAttrs = {};
            for (const [key, value] of params)pmAttrs[key] = value;
            // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
            media.pmAttrs = pmAttrs;
        }
    } catch  {}
    const mediaSingleClose = (0, $7MY8y.createToken)(state, 'media_single_close');
    acc.push(mediaSingleOpen, media, mediaSingleClose);
};
const $3f17de48a6931d92$var$createInlineTokens = (content, state, acc)=>{
    const paragraphOpen = (0, $7MY8y.createToken)(state, 'paragraph_open');
    const inline = (0, $7MY8y.createToken)(state, 'inline');
    inline.content = content;
    inline.children = [
        (0, $7MY8y.createToken)(state, 'text')
    ];
    const paragraphClose = (0, $7MY8y.createToken)(state, 'paragraph_close');
    acc.push(paragraphOpen, inline, paragraphClose);
};
/**
 * Splits the content of the inline token
 * Inline tokens can contain multiple media elements as well as regular text
 * We split the content into an array of strings which can then be converted into the correct tokens
 */ const $3f17de48a6931d92$var$findContent = (token)=>{
    let content = [];
    let lastIndex = 0;
    let match;
    $3f17de48a6931d92$var$mediaRegex.lastIndex = 0;
    // eslint-disable-next-line no-cond-assign
    while((match = $3f17de48a6931d92$var$mediaRegex.exec(token.content)) !== null){
        const matchedString = match[0];
        const matchIndex = match.index;
        if (lastIndex < matchIndex) content.push(token.content.substring(lastIndex, matchIndex));
        content.push(matchedString);
        lastIndex = matchIndex + matchedString.length;
    }
    if (lastIndex < token.content.length) content.push(token.content.substring(lastIndex));
    content = content.filter((item)=>item.length > 0);
    return content;
};
function $3f17de48a6931d92$export$2e2bcd8739ae039(md) {
    md.core.ruler.before('inline', 'media', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'inline' && $3f17de48a6931d92$var$mediaRegex.test(token.content)) {
                // If the previous token is a paragraph_open we want to remove it
                if ($3f17de48a6931d92$var$checkPreviousToken('paragraph_open', acc)) acc.pop();
                const content = $3f17de48a6931d92$var$findContent(token);
                content.forEach((item)=>{
                    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
                    const doesMatch = $3f17de48a6931d92$var$INLINE_MEDIA_MATCH_REGEX.test(item);
                    if (doesMatch) $3f17de48a6931d92$var$createMediaTokens(item, state, acc);
                    else $3f17de48a6931d92$var$createInlineTokens(item, state, acc);
                });
            // If the current token is paragraph close we want to make sure that the previous token isn't a media_single_close
            // or paragraph_close
            } else if (type === 'paragraph_close') {
                if (!$3f17de48a6931d92$var$checkPreviousToken('media_single_close', acc) && !$3f17de48a6931d92$var$checkPreviousToken('paragraph_close', acc)) acc.push(token);
            } else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("9tykg", function(module, exports) {
$parcel$export(module.exports, "default", () => $811470bd95061a4c$export$2e2bcd8739ae039);
// File copied from packages/editor/editor-core/src/plugins/paste/paragraph-md-plugin.ts
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $811470bd95061a4c$var$paragraph = (state, startLine /*, endLine*/ )=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$811470bd95061a4c$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $811470bd95061a4c$var$paragraph);

});

parcelRegister("d5C9r", function(module, exports) {
$parcel$export(module.exports, "default", () => $11bccb76849cfb3f$export$2e2bcd8739ae039);

var $7MY8y = parcelRequire("7MY8y");

const $11bccb76849cfb3f$var$bulletListOpen = 'bullet_list_open';
const $11bccb76849cfb3f$var$bulletListClose = 'bullet_list_close';
const $11bccb76849cfb3f$var$listItemOpen = 'list_item_open';
const $11bccb76849cfb3f$var$listItemClose = 'list_item_close';
const $11bccb76849cfb3f$var$taskListOpen = 'task_list_open';
const $11bccb76849cfb3f$var$taskListClose = 'task_list_close';
const $11bccb76849cfb3f$var$taskItemOpen = 'task_item_open';
const $11bccb76849cfb3f$var$taskItemClose = 'task_item_close';
const $11bccb76849cfb3f$var$paragraphOpen = 'paragraph_open';
const $11bccb76849cfb3f$var$paragraphClose = 'paragraph_close';
function $11bccb76849cfb3f$var$checkTypeByIndex(acc, type, indexOffset = -1) {
    return acc[acc.length + indexOffset]?.type === type;
}
function $11bccb76849cfb3f$var$getTokenByIndex(acc, indexOffset = -1) {
    return acc[acc.length + indexOffset];
}
function $11bccb76849cfb3f$var$handleBulletListOpen(state, token, acc, index) {
    const isPreviousTokenInline = $11bccb76849cfb3f$var$checkTypeByIndex(acc, 'inline');
    const isStartOfTaskList = state.tokens[index + 3].type === 'inline' && $11bccb76849cfb3f$var$startsWithTodoMarkdown(state.tokens[index + 3]);
    // If the previous token is inline and our current token is a bullet_list_open that
    // means we have found the start of a nested list, due to current ADF limitations task items
    // cannot contain new task lists so first we must close the task item and then convert the
    // bullet_list_open to task_list_open
    if (isPreviousTokenInline) {
        acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskItemClose, $11bccb76849cfb3f$var$getTokenByIndex(acc).level - 1));
        acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListOpen, $11bccb76849cfb3f$var$getTokenByIndex(acc).level));
    } else if (isStartOfTaskList) acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListOpen));
    else acc.push(token);
}
function $11bccb76849cfb3f$var$handleBulletListClose(state, token, acc) {
    const isPreviousTokenTaskItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemClose);
    const isPreviousTokenTaskListClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose);
    if (isPreviousTokenTaskItemClose || isPreviousTokenTaskListClose) acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListClose, $11bccb76849cfb3f$var$getTokenByIndex(acc).level - 1));
    else acc.push(token);
}
function $11bccb76849cfb3f$var$handleListItemOpen(state, token, acc, index) {
    const newTaskItemOpen = (0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskItemOpen);
    const isTaskItem = state.tokens[index + 2].type === 'inline' && $11bccb76849cfb3f$var$startsWithTodoMarkdown(state.tokens[index + 2]);
    const isPreviousTokenTaskItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemClose);
    const isPreviousTokenListItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$listItemClose);
    const isPreviousTokenTaskListClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose);
    if (isTaskItem) {
        // If the previous token is a list item close then we have run into some incorrect task list / list markdown
        // We need to complete the previous bullet list and then open a new task list
        if (isPreviousTokenListItemClose) {
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$bulletListClose));
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListOpen));
        }
        newTaskItemOpen.meta = $11bccb76849cfb3f$var$isDone(state.tokens[index + 2]);
        newTaskItemOpen.level = $11bccb76849cfb3f$var$getTokenByIndex(acc).level + (isPreviousTokenTaskListClose ? 0 : 1);
        acc.push(newTaskItemOpen);
    } else {
        // If the previous token is a task item close but the current token is not a task item we need to
        // close the current task item list and then open a new bullet list
        if (isPreviousTokenTaskItemClose) {
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListClose));
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$bulletListOpen));
        }
        acc.push(token);
    }
}
function $11bccb76849cfb3f$var$handleListItemClose(state, token, acc) {
    const isWithinTaskList = $11bccb76849cfb3f$var$checkTypeByIndex(acc, 'inline') && $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen, -2);
    if (isWithinTaskList) acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskItemClose, $11bccb76849cfb3f$var$getTokenByIndex(acc, -2).level));
    else if (!$11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose)) acc.push(token);
}
function $11bccb76849cfb3f$var$handleInline(token, acc) {
    if (token.children?.[0]) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    token.children[0].content = $11bccb76849cfb3f$var$removeTodoMarkdown(token.children[0].content);
    token.content = $11bccb76849cfb3f$var$removeTodoMarkdown(token.content);
    token.level = $11bccb76849cfb3f$var$getTokenByIndex(acc).level + 1;
    acc.push(token);
}
function $11bccb76849cfb3f$var$handleParagraphs(token, acc) {
    const isWithinTaskItem = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen) || $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen, -2);
    if (!isWithinTaskItem) acc.push(token);
}
function $11bccb76849cfb3f$var$isInlineAfterTaskItemOpen(token, acc) {
    return token.type === 'inline' && acc[acc.length - 1].type === $11bccb76849cfb3f$var$taskItemOpen;
}
function $11bccb76849cfb3f$var$startsWithTodoMarkdown(token) {
    // leading whitespace in a list item is already trimmed off by markdown-it
    return token.content.indexOf('[ ] ') === 0 || token.content.indexOf('[x] ') === 0 || token.content.indexOf('[X] ') === 0;
}
function $11bccb76849cfb3f$var$removeTodoMarkdown(content) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regex = /(\[x\]\s)|(\[\s\]\s)/;
    return content.replace(regex, '');
}
function $11bccb76849cfb3f$var$isDone(token) {
    if (token.content.indexOf('[ ] ') === 0) return 'TODO';
    else return 'DONE';
}
function $11bccb76849cfb3f$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'github-task-lists', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $11bccb76849cfb3f$var$bulletListOpen) $11bccb76849cfb3f$var$handleBulletListOpen(state, token, acc, index);
            else if (type === $11bccb76849cfb3f$var$bulletListClose) $11bccb76849cfb3f$var$handleBulletListClose(state, token, acc);
            else if (type === $11bccb76849cfb3f$var$listItemOpen) $11bccb76849cfb3f$var$handleListItemOpen(state, token, acc, index);
            else if ($11bccb76849cfb3f$var$isInlineAfterTaskItemOpen(token, acc)) $11bccb76849cfb3f$var$handleInline(token, acc);
            else if (type === $11bccb76849cfb3f$var$listItemClose) $11bccb76849cfb3f$var$handleListItemClose(state, token, acc);
            else if (type === $11bccb76849cfb3f$var$paragraphOpen || type === $11bccb76849cfb3f$var$paragraphClose) $11bccb76849cfb3f$var$handleParagraphs(token, acc);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});


//# sourceMappingURL=gic-anywhere.980a6f08.js.map
